import { mapGetters, mapState } from 'vuex';
import draggable from "vuedraggable";
import {
  DxScrolling,
  DxPager,
  DxPaging,
  DxSelection,
  DxDataGrid,
  DxColumn,
  DxLoadPanel,
  DxGrouping,
} from "devextreme-vue/data-grid"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { getEInvoiceConfiguration } from "@/api/action-defines/e-invoice-management.js";
import { v4 as uuidv4 } from 'uuid';
import { INVOICE_ACTION } from '@/@core/data/enum/eInvoiceActionType';
import { showToast } from '@/@core/utils/utils';
import { getMinorUnitApi } from "@/api/action-defines/site-management";
import ItemEditPopup from './ItemEditPopup.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    DxSelection,
    DxDataGrid,
    DxScrolling,
    DxPager,
    DxPaging,
    DxColumn,
    DxLoadPanel,
    DxGrouping,
    draggable,
    VuePerfectScrollbar,
    ItemEditPopup
  },

  props: {
    actionType: {
      type: String,
      required: false,
      default: INVOICE_ACTION.ADD_INVOICE,
    },
    displayType: {
      type: String,
      required: false,
      default: '',
    }
  },

  data() {
    return {
      eInvoiceConfig: {
        MinorUnit: 2,
        PriceMinorUnit: 2,
      },
      defaultConfigs: {
        VAT_INVOICE: {
          InvoiceType: "VAT_INVOICE",
          ChargeOption: "SEPARATE_COLUMN",
          DiscountOption: "SEPARATE_COLUMN",
          ShowChargePercent: true,
          ShowRepresentativeName: true,
          ShowTaxDetail: true,
          ShowTaxPercent: true,
          TaxOption: "SEPARATE_COLUMN"
        },
        BH_INVOICE: {
          InvoiceType: "BH_INVOICE",
          ChargeOption: "SEPARATE_COLUMN",
          DiscountOption: "SEPARATE_COLUMN",
          ShowChargePercent: true,
          ShowRepresentativeName: true,
          ShowTaxDetail: true,
          ShowTaxPercent: true,
          TaxOption: "SEPARATE_COLUMN"
        },
        SALES_INVOICE: {
          InvoiceType: "SALES_INVOICE",
          ChargeOption: "SEPARATE_COLUMN",
          DiscountOption: "SEPARATE_COLUMN",
          ShowChargePercent: true,
          ShowRepresentativeName: true,
          ShowTaxDetail: false,
          ShowTaxPercent: false,
          TaxOption: "SEPARATE_COLUMN"
        }
      },
      chargeOptions: [
        { value: "SEPARATE_COLUMN", text: "Hiển thị ở cột riêng" },
        { value: "ADD_TO_UNIT_PRICE", text: "Gộp vào đơn giá" },
        { value: "DISPLAY_IN_TOTAL", text: "Hiển thị ở tổng" },
        { value: "SEPARATE_ROW", text: "Tách thành dòng riêng" }
      ],
      typeDisplay: this.displayType,
      isAutoCalculateMoney: false,
      groupedItems: [],
      groupId: 1,
      itemId: 0,
      collapseState: {},
      isCheckedAll: false,
      status: false,
      drag: false,
      pagingItems: [],
      pagingGroupItems: [],
      selectedItems: [], // Items to form a new group
      selectedEditItem: {}, // Item đang được chỉnh sửa trong popup
      groupOption: [
        { value: 'GroupItemId', text: 'e_invoice_management_product_name_or_service_name' },
        //{ value: 'UnitName', text: 'common_unit' },
        //{ value: 'Price', text: 'common_unit_price' },
        { value: 'Charges', text: 'tax_fee' },
        //{ value: 'Tax', text: 'common_tax_percent' },
        //{ value: 'SpecialTax', text: 'common_special_tax_percent' },
      ],
      selectedGroupOption: '',
      nonGroupId: '',
      editingCell: {
        row: null,
        field: null
      },
      editingGroupName: '',
      editingGroupUnitName: '',
      items: [],
      //Pagination
      paging: {
        PageSize: 20,
        PageIndex: 1,
      },
      totalPagination: {
        TotalRecord: 0,
        TotalPage: 0,
      },
      // Draggable
      draggedItem: null,
      originalGroup: null,
      // E-invoice config
      eInvoiceConfig: {},
    };
  },
  async created() {
    
    await this.getEConfig();
    await this.loadMinorUnitConfig();

    // Đảm bảo ItemId duy nhất - tạo bản sao sâu của dữ liệu
    //this.items = structuredClone(this.$ls_Items);

    // Khởi tạo giá trị hiển thị cho các item
    this.items.map(item => {
      // Thêm trường isChecked mà không làm thay đổi dữ liệu gốc
      this.$set(item, 'isChecked', false);
      
      // Tính toán DisplayUnitPrice chỉ để hiển thị
      const displayPrice = this.calculateUnitPrice(item);
      this.$set(item, 'DisplayUnitPrice', displayPrice);
      
      // Xử lý các giá trị hiển thị
      if (!this.isAutoCalculateMoney) {
        // Lưu giá trị gốc vào Pre để hiển thị
        this.$set(item, 'PreChargesAmount', item.ChargesAmount);
        this.$set(item, 'PreTaxAmount', item.TaxAmount);
        this.$set(item, 'PreTotalAmount', item.TotalAmount);
      } else {
        // Tính toán các giá trị để hiển thị
        const chargeAmount = this.calculateChargeAmount(item);
        const taxAmount = this.calculateTaxAmount(item);
        const totalAmount = this.calculateTotalAmount(item);
        
        // Lưu vào Pre để hiển thị, không làm thay đổi dữ liệu gốc
        this.$set(item, 'PreChargesAmount', chargeAmount);
        this.$set(item, 'PreTaxAmount', taxAmount);
        this.$set(item, 'PreTotalAmount', totalAmount);
      }

      // Tính TaxReduction43Amount nếu là BH_INVOICE và giá trị từ API bằng 0
      if (this.isBHInvoice && !(+item.TaxReduction43Amount > 0)) {
        this.$set(item, 'TaxReduction43Amount', this.calculateTaxReduction(item));
      }
    });
    
    //Assign Paging
    this.totalPagination.TotalRecord = this.items.length;
    this.totalPagination.TotalPage = Math.ceil(
      this.totalPagination.TotalRecord / this.paging.PageSize,
    );
    //Take first page
    this.getPagingItems();
    this.getPagingItemGroup();
    
    // Validate dữ liệu ban đầu để tránh duplicate keys
    this.validateAndCleanData();

    this.groupOption.map(option => {
      option.text = this.$t(option.text);
    })

  },
  computed: {
    ...mapState({
      $ls_Items: (state) => state.eInvoiceManagement.items,
      $ls_Groups: (state) => state.eInvoiceManagement.groups,
      $ls_Invoices: (state) => state.eInvoiceManagement.invoices,
      $ls_IsSelectedAll: (state) => state.eInvoiceManagement.isSelectedAll,
    }),
    ...mapGetters({
      $ls_GetTableItems: 'eInvoiceManagement/getTableItems',
    }),
    
    // Check if component is in view_detail mode (read-only)
    isViewDetailMode() {
      return this.typeDisplay === 'view_detail';
    },
    
    dragOptions: function () {
      return {
        animation: 200,
        group: "sharedGroup",  // Tên nhóm để chia sẻ giữa các group khác nhau
        disabled: this.isViewDetailMode, // Disable dragging in view detail mode
        ghostClass: "ghost"
      };
    },
    selectedGroupOptionText() {
      return this.groupOption.find(option => option.value === this.selectedGroupOption)?.text || this.$t('common_grouping_option');
    },
    //Check group button whether disable or not
    haveDifferentChargeOrTaxes() {
      const chargeArr = [];
      const taxArr = [];
      // const specialTaxArr = [];
      this.selectedItems.map(item => {
        chargeArr.push(+item.Charges);
        taxArr.push(+item.Tax);
        // specialTaxArr.push(+item.SpecialTax);
      })
      const chargeSetSize = new Set(chargeArr).size;
      const taxSetSize = new Set(taxArr).size;
      // const specialTaxSetSize =  new Set(specialTaxArr).size;
      // Check if items unique
      // if(chargeSetSize === 1 && taxSetSize === 1 && specialTaxSetSize === 1) {
      if (chargeSetSize === 1 && taxSetSize === 1) {
        return false;
      }

      return true;
    },

    isSelectedGreaterThanOne() {
      return this.selectedItems.length > 1;
    },

    isBHInvoice() {
      return this.eInvoiceConfig.InvoiceType === 'BH_INVOICE';
    },
    taxGroups() {
      if (!Array.isArray(this.items)) return [];

      // Lấy tất cả tax rates từ items, chỉ lấy items có TaxAmount > 0
      const taxRates = this.items
        .filter(item => item.TaxAmount > 0)
        .map(item => item.Tax || 0)
        .filter(rate => rate > 0);

      // Loại bỏ duplicates và sắp xếp
      const uniqueRates = [...new Set(taxRates)].sort((a, b) => a - b);

      return uniqueRates.map(rate => ({
        rate: rate,
        name: `VAT ${rate}%`
      }));
    },
    chargeGroups() {
      if (!Array.isArray(this.items)) return [];

      // Lấy tất cả charge rates từ items, chỉ lấy items có ChargesAmount > 0
      const chargeRates = this.items
        .filter(item => item.ChargesAmount > 0)
        .map(item => item.Charges || 0)
        .filter(rate => rate > 0);

      // Loại bỏ duplicates và sắp xếp
      const uniqueRates = [...new Set(chargeRates)].sort((a, b) => a - b);

      return uniqueRates.map(rate => ({
        rate: rate,
        name: `Charge ${rate}%`
      }));
    },
  },
  methods: {
    async loadMinorUnitConfig() {
      try {
        const res = await getMinorUnitApi();
        if (res && res.StatusCode == "200") {
          this.eInvoiceConfig.MinorUnit = res.Data.MinorUnit;
          this.eInvoiceConfig.PriceMinorUnit = res.Data.PriceMinorUnit;
        } else {
          showToast('warning', 'Không lấy được cấu hình số thập phân');
        }
      } catch (err) {
        showToast('error', 'Lỗi khi lấy cấu hình số thập phân');
      }
    },

    // Helper method to calculate charge amount directly
    calculateChargeDirectly(baseAmount, chargeRate, minorUnit = 0) {
      if (!baseAmount || !chargeRate) return 0;
      const chargeAmount = baseAmount * chargeRate / 100;
      return this.roundTo(chargeAmount, minorUnit);
    },

    openModal() {
      //this.fillItemsDetail(structuredClone(this.$ls_Items));
    },

    roundTo(value, decimals) {
      const factor = Math.pow(10, decimals);
      return Math.round(value * factor) / factor;
    },

    // === UNIT PRICE CALCULATION ===
    calculateUnitPrice(item) {
      if (!item || typeof item !== 'object') return 0;
      
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;

      // Xử lý đặc biệt cho trường hợp SEPARATE_ROW
      if (chargeOption === 'SEPARATE_ROW') {
        // Kiểm tra nếu là dòng phí riêng, không cần xử lý discount
        if (item.IsChargeRow) {
          return +item.Price || 0;
        }
        
        // Nếu là DiscountOption = ADD_TO_UNIT_PRICE, cần trừ discount từ đơn giá
        if (discountOption === 'ADD_TO_UNIT_PRICE') {
          let unitPrice = +item.Price || 0;
          // Tính discount per unit và trừ từ đơn giá
          const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
          unitPrice = unitPrice - discountPerUnit;
          // Làm tròn theo cấu hình
          unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
          return unitPrice > 0 ? unitPrice : 0;
        }
        
        // Nếu là DiscountOption = SEPARATE_COLUMN, không trừ discount từ đơn giá
        return +item.Price || 0;
      }
      
      // Luồng 1: VAT_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateUnitPrice_VAT_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 2: VAT_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateUnitPrice_VAT_SEPARATE_ADD(item);
      }
      
      // Luồng 3: VAT_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateUnitPrice_VAT_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 4: VAT_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateUnitPrice_VAT_ADD_SEPARATE(item);
      }
      
      // Luồng 5: VAT_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateUnitPrice_VAT_ADD_ADD(item);
      }
      
      // Luồng 6: VAT_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateUnitPrice_VAT_ADD_DISPLAY(item);
      }
      
      // Luồng 7: BH_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateUnitPrice_BH_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 8: BH_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateUnitPrice_BH_SEPARATE_ADD(item);
      }
      
      // Luồng 9: BH_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateUnitPrice_BH_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 10: BH_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateUnitPrice_BH_ADD_SEPARATE(item);
      }
      
      // Luồng 11: BH_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateUnitPrice_BH_ADD_ADD(item);
      }
      
      // Luồng 12: BH_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateUnitPrice_BH_ADD_DISPLAY(item);
      }
      
      // Default fallback
      return +item.Price || 0;
    },

    // === UNIT PRICE CALCULATION METHODS ===
    calculateUnitPrice_VAT_SEPARATE_SEPARATE(item) {
      // VAT_INVOICE + Discount riêng + Charge riêng
      let unitPrice = +item.Price || 0;
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_VAT_SEPARATE_ADD(item) {
      // VAT_INVOICE + Discount riêng + Charge gộp vào đơn giá
      let unitPrice = +item.Price || 0;
      
      if ((+item.Charges || 0) > 0) {
        const baseForCharge = (unitPrice * (+item.Quantity || 1)) - item.DiscountAmount;
        const chargePerUnit = baseForCharge * (+item.Charges || 0) / 100 / (+item.Quantity || 1);
        unitPrice += chargePerUnit;
      }
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_VAT_SEPARATE_DISPLAY(item) {
      // VAT_INVOICE + Discount riêng + Charge hiển thị ở tổng
      let unitPrice = +item.Price || 0;
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_VAT_ADD_SEPARATE(item) {
      // VAT_INVOICE + Discount gộp vào đơn giá + Charge riêng
      let unitPrice = +item.Price || 0;
      
      const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
      unitPrice = unitPrice - discountPerUnit;
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_VAT_ADD_ADD(item) {
      // VAT_INVOICE + Discount gộp vào đơn giá + Charge gộp vào đơn giá
      let unitPrice = +item.Price || 0;
      
      const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
      unitPrice = unitPrice - discountPerUnit;
      
      if ((+item.Charges || 0) > 0) {
        const baseForCharge = unitPrice * (+item.Quantity || 1);
        const chargePerUnit = baseForCharge * (+item.Charges || 0) / 100 / (+item.Quantity || 1);
        unitPrice += chargePerUnit;
      }
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_VAT_ADD_DISPLAY(item) {
      // VAT_INVOICE + Discount gộp vào đơn giá + Charge hiển thị ở tổng
      let unitPrice = +item.Price || 0;
      
      const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
      unitPrice = unitPrice - discountPerUnit;
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_BH_SEPARATE_SEPARATE(item) {
      // BH_INVOICE + Discount riêng + Charge riêng
      let unitPrice = +item.Price || 0;
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_BH_SEPARATE_ADD(item) {
      // BH_INVOICE + Discount riêng + Charge gộp vào đơn giá
      let unitPrice = +item.Price || 0;
      
      if ((+item.Charges || 0) > 0) {
        const baseForCharge = unitPrice * (+item.Quantity || 1);
        const discountAmount = (+item.DiscountAmount || 0);
        const chargePerUnit = (baseForCharge - discountAmount) * (+item.Charges || 0) / 100 / (+item.Quantity || 1);
        unitPrice += chargePerUnit;
      }
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_BH_SEPARATE_DISPLAY(item) {
      // BH_INVOICE + Discount riêng + Charge hiển thị ở tổng
      let unitPrice = +item.Price || 0;
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_BH_ADD_SEPARATE(item) {
      // BH_INVOICE + Discount gộp vào đơn giá + Charge riêng
      let unitPrice = +item.Price || 0;
      
      const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
      unitPrice = unitPrice - discountPerUnit;
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_BH_ADD_ADD(item) {
      // BH_INVOICE + Discount gộp vào đơn giá + Charge gộp vào đơn giá
      let unitPrice = +item.Price || 0;
      
      const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
      unitPrice = unitPrice - discountPerUnit;
      
      if ((+item.Charges || 0) > 0) {
        const baseForCharge = unitPrice * (+item.Quantity || 1);
        const chargePerUnit = baseForCharge * (+item.Charges || 0) / 100 / (+item.Quantity || 1);
        unitPrice += chargePerUnit;
      }
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateUnitPrice_BH_ADD_DISPLAY(item) {
      // BH_INVOICE + Discount gộp vào đơn giá + Charge hiển thị ở tổng
      let unitPrice = +item.Price || 0;
      
      const discountPerUnit = (+item.DiscountAmount || 0) / Math.max(+item.Quantity || 1, 1);
      unitPrice = unitPrice - discountPerUnit;
      
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      return unitPrice > 0 ? unitPrice : 0;
    },

    // === CHARGE AMOUNT CALCULATION ===
    calculateChargeAmount(item) {
      if (!item || typeof item !== 'object' || !(+item.Charges > 0) || (!(+item.Price > 0) || !(+item.DisplayUnitPrice > 0))) {
        return 0;
      }
      
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;
      
      // Nếu charge gộp vào đơn giá hoặc tách riêng thành dòng thì không tính riêng
      if (chargeOption === 'ADD_TO_UNIT_PRICE' || chargeOption === 'SEPARATE_ROW') {
        return 0;
      }
      
      // Luồng 1: VAT_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateChargeAmount_VAT_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 2: VAT_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateChargeAmount_VAT_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 3: VAT_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateChargeAmount_VAT_ADD_SEPARATE(item);
      }
      
      // Luồng 4: VAT_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateChargeAmount_VAT_ADD_DISPLAY(item);
      }
      
      // Luồng 5: BH_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateChargeAmount_BH_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 6: BH_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateChargeAmount_BH_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 7: BH_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateChargeAmount_BH_ADD_SEPARATE(item);
      }
      
      // Luồng 8: BH_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateChargeAmount_BH_ADD_DISPLAY(item);
      }
      
      return 0;
    },

    // === CHARGE AMOUNT CALCULATION METHODS ===
    calculateChargeAmount_VAT_SEPARATE_SEPARATE(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const baseAfterDiscount = baseAmount - discountAmount;
      
      return this.calculateChargeDirectly(
        baseAfterDiscount, 
        +item.Charges, 
        this.eInvoiceConfig.MinorUnit
      );
    },

    calculateChargeAmount_VAT_SEPARATE_DISPLAY(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const baseAfterDiscount = baseAmount - discountAmount;
      
      return this.calculateChargeDirectly(
        baseAfterDiscount, 
        +item.Charges, 
        this.eInvoiceConfig.MinorUnit
      );
    },

    calculateChargeAmount_VAT_ADD_SEPARATE(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_SEPARATE(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      
      return this.calculateChargeDirectly(
        baseAmount, 
        +item.Charges, 
        this.eInvoiceConfig.MinorUnit
      );
    },

    calculateChargeAmount_VAT_ADD_DISPLAY(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_DISPLAY(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      
      return this.calculateChargeDirectly(
        baseAmount, 
        +item.Charges, 
        this.eInvoiceConfig.MinorUnit
      );
    },

    calculateChargeAmount_BH_SEPARATE_SEPARATE(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const baseAfterDiscount = baseAmount - discountAmount;
      
      let chargeAmount = baseAfterDiscount * (+item.Charges || 0) / 100;
      chargeAmount = this.roundTo(chargeAmount, this.eInvoiceConfig.MinorUnit || 0);
      return chargeAmount > 0 ? chargeAmount : 0;
    },

    calculateChargeAmount_BH_SEPARATE_DISPLAY(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const baseAfterDiscount = baseAmount - discountAmount;
      
      let chargeAmount = baseAfterDiscount * (+item.Charges || 0) / 100;
      chargeAmount = this.roundTo(chargeAmount, this.eInvoiceConfig.MinorUnit || 0);
      return chargeAmount > 0 ? chargeAmount : 0;
    },

    calculateChargeAmount_BH_ADD_SEPARATE(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_SEPARATE(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      
      let chargeAmount = baseAmount * (+item.Charges || 0) / 100;
      chargeAmount = this.roundTo(chargeAmount, this.eInvoiceConfig.MinorUnit || 0);
      return chargeAmount > 0 ? chargeAmount : 0;
    },

    calculateChargeAmount_BH_ADD_DISPLAY(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_DISPLAY(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      
      let chargeAmount = baseAmount * (+item.Charges || 0) / 100;
      chargeAmount = this.roundTo(chargeAmount, this.eInvoiceConfig.MinorUnit || 0);
      return chargeAmount > 0 ? chargeAmount : 0;
    },

    // === TAX AMOUNT CALCULATION ===
    calculateTaxAmount(item) {
      if (!item || typeof item !== 'object' || !(+item.Tax > 0) || (!(+item.Price > 0) || !(+item.DisplayUnitPrice > 0))) {
        return 0;
      }
      
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;
      
      // Xử lý đặc biệt cho trường hợp SEPARATE_ROW hoặc item đã được xử lý bởi SEPARATE_ROW
      if (chargeOption === 'SEPARATE_ROW' || item.ProcessedBySeparateRow) {
        // Đối với dòng phí riêng, đã tính thuế trên giá trị phí
        if (item.IsChargeRow) {
          return this.roundTo(item.Price * (+item.Tax || 0) / 100, this.eInvoiceConfig.MinorUnit);
        }
        
        // Đối với các dòng sản phẩm thông thường, tính thuế trên giá trị không bao gồm phí
        const baseAmount = (+item.Quantity || 1) * (+item.Price || 0) - (+item.DiscountAmount || 0);
        return this.roundTo(baseAmount * (+item.Tax || 0) / 100, this.eInvoiceConfig.MinorUnit);
      }
      
      // Luồng 1: VAT_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTaxAmount_VAT_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 2: VAT_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTaxAmount_VAT_SEPARATE_ADD(item);
      }
      
      // Luồng 3: VAT_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTaxAmount_VAT_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 4: VAT_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTaxAmount_VAT_ADD_SEPARATE(item);
      }
      
      // Luồng 5: VAT_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTaxAmount_VAT_ADD_ADD(item);
      }
      
      // Luồng 6: VAT_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTaxAmount_VAT_ADD_DISPLAY(item);
      }
      
      // Luồng 7: BH_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTaxAmount_BH_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 8: BH_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTaxAmount_BH_SEPARATE_ADD(item);
      }
      
      // Luồng 9: BH_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTaxAmount_BH_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 10: BH_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTaxAmount_BH_ADD_SEPARATE(item);
      }
      
      // Luồng 11: BH_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTaxAmount_BH_ADD_ADD(item);
      }
      
      // Luồng 12: BH_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTaxAmount_BH_ADD_DISPLAY(item);
      }
      
      return 0;
    },

    // === TAX AMOUNT CALCULATION METHODS ===
    calculateTaxAmount_VAT_SEPARATE_SEPARATE(item) {
      // Bước 1: Tính tổng tiền hàng (số lượng * đơn giá)
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      // Bước 2: Trừ chiết khấu
      const discountAmount = (+item.DiscountAmount || 0);
      // Bước 3: Lấy giá trị thực của phụ phí
      let chargeAmount = (+item.ChargesAmount || 0);
      // Nếu chargeAmount = 0 nhưng Charges > 0, tính trực tiếp
      if (chargeAmount === 0 && (+item.Charges || 0) > 0) {
        chargeAmount = this.calculateChargeDirectly(
          baseAmount - discountAmount, 
          +item.Charges, 
          this.eInvoiceConfig.MinorUnit
        );
      }
      // Bước 4: Tính thuế trên (tổng tiền hàng - chiết khấu + phụ phí)
      const taxableAmount = baseAmount - discountAmount + chargeAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_VAT_SEPARATE_ADD(item) {
      // Khi phí đã gộp vào đơn giá
      // Bước 1: Lấy đơn giá đã bao gồm phí
      const unitPriceWithCharge = this.calculateUnitPrice_VAT_SEPARATE_ADD(item);
      // Bước 2: Tính tổng tiền hàng (số lượng * đơn giá đã bao gồm phí)
      const baseAmount = (+item.Quantity || 1) * unitPriceWithCharge;
      // Bước 3: Trừ chiết khấu
      const discountAmount = (+item.DiscountAmount || 0);
      // Bước 4: Tính thuế trên (tổng tiền hàng - chiết khấu)
      const taxableAmount = baseAmount - discountAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_VAT_SEPARATE_DISPLAY(item) {
      // Khi hiển thị phí ở tổng
      // Bước 1: Tính tổng tiền hàng (số lượng * đơn giá)
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      // Bước 2: Trừ chiết khấu
      const discountAmount = (+item.DiscountAmount || 0);
      // Bước 3: Tính thuế trên (tổng tiền hàng - chiết khấu)
      // Lưu ý: với DISPLAY_IN_TOTAL, phí không được tính vào để tính thuế
      const taxableAmount = baseAmount - discountAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_VAT_ADD_SEPARATE(item) {
      // Khi chiết khấu đã gộp vào đơn giá, phí tính riêng
      // Bước 1: Lấy đơn giá đã trừ chiết khấu
      const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_SEPARATE(item);
      // Bước 2: Tính tổng tiền hàng (số lượng * đơn giá đã trừ chiết khấu)
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      // Bước 3: Lấy giá trị thực của phụ phí
      let chargeAmount = (+item.ChargesAmount || 0);
      // Nếu chargeAmount = 0 nhưng Charges > 0, tính trực tiếp
      if (chargeAmount === 0 && (+item.Charges || 0) > 0) {
        chargeAmount = this.calculateChargeDirectly(
          baseAmount, 
          +item.Charges, 
          this.eInvoiceConfig.MinorUnit
        );
      }
      // Bước 4: Tính thuế trên (tổng tiền hàng + phụ phí)
      const taxableAmount = baseAmount + chargeAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_VAT_ADD_ADD(item) {
      // Khi cả chiết khấu và phí đã gộp vào đơn giá
      // Bước 1: Lấy đơn giá đã bao gồm chiết khấu và phí
      const unitPriceWithDiscountAndCharge = this.calculateUnitPrice_VAT_ADD_ADD(item);
      // Bước 2: Tính tổng tiền hàng (số lượng * đơn giá tổng hợp)
      const taxableAmount = (+item.Quantity || 1) * unitPriceWithDiscountAndCharge;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_VAT_ADD_DISPLAY(item) {
      // Khi chiết khấu đã gộp vào đơn giá, phí hiển thị ở tổng
      // Bước 1: Lấy đơn giá đã trừ chiết khấu
      const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_DISPLAY(item);
      // Bước 2: Tính tổng tiền hàng (số lượng * đơn giá đã trừ chiết khấu)
      const taxableAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      // Lưu ý: với DISPLAY_IN_TOTAL, phí không được tính vào để tính thuế
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_BH_SEPARATE_SEPARATE(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const chargeAmount = (+item.ChargesAmount || 0);
      const taxableAmount = baseAmount - discountAmount + chargeAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_BH_SEPARATE_ADD(item) {
      const unitPriceWithCharge = this.calculateUnitPrice_BH_SEPARATE_ADD(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceWithCharge;
      const discountAmount = (+item.DiscountAmount || 0);
      const taxableAmount = baseAmount - discountAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_BH_SEPARATE_DISPLAY(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const taxableAmount = baseAmount - discountAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_BH_ADD_SEPARATE(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_SEPARATE(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      const chargeAmount = (+item.ChargesAmount || 0);
      const taxableAmount = baseAmount + chargeAmount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_BH_ADD_ADD(item) {
      const unitPriceWithDiscountAndCharge = this.calculateUnitPrice_BH_ADD_ADD(item);
      const taxableAmount = (+item.Quantity || 1) * unitPriceWithDiscountAndCharge;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    calculateTaxAmount_BH_ADD_DISPLAY(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_DISPLAY(item);
      const taxableAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      
      let taxAmount = taxableAmount * (+item.Tax || 0) / 100;
      taxAmount = this.roundTo(taxAmount, this.eInvoiceConfig.MinorUnit || 0);
      return taxAmount > 0 ? taxAmount : 0;
    },

    // === TOTAL AMOUNT CALCULATION ===
    calculateTotalAmount(item) {
      if (!item || typeof item !== 'object' || (!(+item.Price > 0) || !(+item.DisplayUnitPrice > 0))) {
        return 0;
      }
      
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;
      
      // Xử lý đặc biệt cho trường hợp SEPARATE_ROW hoặc item đã được xử lý bởi SEPARATE_ROW
      if (chargeOption === 'SEPARATE_ROW' || item.ProcessedBySeparateRow) {
        // Đối với dòng phí riêng, tổng tiền = giá trị phí + thuế
        if (item.IsChargeRow) {
          const taxAmount = item.TaxAmount || this.calculateTaxAmount(item);
          return this.roundTo(item.Price + taxAmount, this.eInvoiceConfig.MinorUnit);
        }
        
        // Đối với dòng sản phẩm, tổng tiền = (số lượng * đơn giá - giảm giá) + thuế
        const baseAmount = (+item.Quantity || 1) * (+item.Price || 0) - (+item.DiscountAmount || 0);
        const taxAmount = item.TaxAmount || this.calculateTaxAmount(item);
        return this.roundTo(baseAmount + taxAmount, this.eInvoiceConfig.MinorUnit);
      }
      
      // Luồng 1: VAT_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTotalAmount_VAT_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 2: VAT_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTotalAmount_VAT_SEPARATE_ADD(item);
      }
      
      // Luồng 3: VAT_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTotalAmount_VAT_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 4: VAT_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTotalAmount_VAT_ADD_SEPARATE(item);
      }
      
      // Luồng 5: VAT_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTotalAmount_VAT_ADD_ADD(item);
      }
      
      // Luồng 6: VAT_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTotalAmount_VAT_ADD_DISPLAY(item);
      }
      
      // Luồng 7: BH_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTotalAmount_BH_SEPARATE_SEPARATE(item);
      }
      
      // Luồng 8: BH_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTotalAmount_BH_SEPARATE_ADD(item);
      }
      
      // Luồng 9: BH_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTotalAmount_BH_SEPARATE_DISPLAY(item);
      }
      
      // Luồng 10: BH_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        return this.calculateTotalAmount_BH_ADD_SEPARATE(item);
      }
      
      // Luồng 11: BH_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        return this.calculateTotalAmount_BH_ADD_ADD(item);
      }
      
      // Luồng 12: BH_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        return this.calculateTotalAmount_BH_ADD_DISPLAY(item);
      }
      
      return 0;
    },

    // === TOTAL AMOUNT CALCULATION METHODS ===
    calculateTotalAmount_VAT_SEPARATE_SEPARATE(item) {
      // Tính tiền hàng (số lượng * đơn giá)
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      // Trừ chiết khấu
      const discountAmount = (+item.DiscountAmount || 0);
      // Cộng phí (tính từ hàm chuyên dụng)
      const chargeAmount = this.calculateChargeAmount_VAT_SEPARATE_SEPARATE(item);
      // Cộng thuế (tính từ hàm chuyên dụng)
      const taxAmount = this.calculateTaxAmount_VAT_SEPARATE_SEPARATE(item);
      
      // Tổng = Tiền hàng - Chiết khấu + Phí + Thuế
      let totalAmount = baseAmount - discountAmount + chargeAmount + taxAmount;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_VAT_SEPARATE_ADD(item) {
      // Lấy đơn giá đã bao gồm phí
      const unitPriceWithCharge = this.calculateUnitPrice_VAT_SEPARATE_ADD(item);
      // Tính tiền hàng đã bao gồm phí (số lượng * đơn giá có phí)
      const baseAmount = (+item.Quantity || 1) * unitPriceWithCharge;
      // Trừ chiết khấu
      const discountAmount = (+item.DiscountAmount || 0);
      // Cộng thuế (tính từ hàm chuyên dụng)
      const taxAmount = this.calculateTaxAmount_VAT_SEPARATE_ADD(item);
      
      // Tổng = Tiền hàng có phí - Chiết khấu + Thuế
      let totalAmount = baseAmount - discountAmount + taxAmount;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_VAT_SEPARATE_DISPLAY(item) {
      // Tính tiền hàng (số lượng * đơn giá)
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      // Trừ chiết khấu
      const discountAmount = (+item.DiscountAmount || 0);
      // Cộng phí (tính từ hàm chuyên dụng) - chỉ hiển thị ở tổng
      const chargeAmount = this.calculateChargeAmount_VAT_SEPARATE_DISPLAY(item);
      // Cộng thuế (tính từ hàm chuyên dụng)
      const taxAmount = this.calculateTaxAmount_VAT_SEPARATE_DISPLAY(item);
      
      // Tổng = Tiền hàng - Chiết khấu + Phí + Thuế
      let totalAmount = baseAmount - discountAmount + chargeAmount + taxAmount;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_VAT_ADD_SEPARATE(item) {
      // Lấy đơn giá đã trừ chiết khấu
      const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_SEPARATE(item);
      // Tính tiền hàng đã trừ chiết khấu (số lượng * đơn giá sau chiết khấu)
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      // Cộng phí (tính từ hàm chuyên dụng)
      const chargeAmount = this.calculateChargeAmount_VAT_ADD_SEPARATE(item);
      // Cộng thuế (tính từ hàm chuyên dụng)
      const taxAmount = this.calculateTaxAmount_VAT_ADD_SEPARATE(item);
      
      // Tổng = Tiền hàng sau chiết khấu + Phí + Thuế
      let totalAmount = baseAmount + chargeAmount + taxAmount;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_VAT_ADD_ADD(item) {
      // Lấy đơn giá đã bao gồm chiết khấu và phí
      const unitPriceWithDiscountAndCharge = this.calculateUnitPrice_VAT_ADD_ADD(item);
      // Tính tiền hàng đã bao gồm chiết khấu và phí
      const baseAmount = (+item.Quantity || 1) * unitPriceWithDiscountAndCharge;
      // Cộng thuế (tính từ hàm chuyên dụng)
      const taxAmount = this.calculateTaxAmount_VAT_ADD_ADD(item);
      
      // Tổng = Tiền hàng tổng hợp + Thuế
      let totalAmount = baseAmount + taxAmount;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_VAT_ADD_DISPLAY(item) {
      // Lấy đơn giá đã trừ chiết khấu
      const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_DISPLAY(item);
      // Tính tiền hàng đã trừ chiết khấu
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      // Cộng phí (tính từ hàm chuyên dụng) - chỉ hiển thị ở tổng
      const chargeAmount = this.calculateChargeAmount_VAT_ADD_DISPLAY(item);
      // Cộng thuế (tính từ hàm chuyên dụng)
      const taxAmount = this.calculateTaxAmount_VAT_ADD_DISPLAY(item);
      
      // Tổng = Tiền hàng sau chiết khấu + Phí + Thuế
      let totalAmount = baseAmount + chargeAmount + taxAmount;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_BH_SEPARATE_SEPARATE(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const chargeAmount = this.calculateChargeAmount_BH_SEPARATE_SEPARATE(item);
      const taxAmount = this.calculateTaxAmount_BH_SEPARATE_SEPARATE(item);
      const taxReduction = this.calculateTaxReduction(item);
      
      // For BH_INVOICE, don't add taxAmount to the total, only subtract taxReduction
      let totalAmount = baseAmount - discountAmount + chargeAmount - taxReduction;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_BH_SEPARATE_ADD(item) {
      const unitPriceWithCharge = this.calculateUnitPrice_BH_SEPARATE_ADD(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceWithCharge;
      const discountAmount = (+item.DiscountAmount || 0);
      const taxAmount = this.calculateTaxAmount_BH_SEPARATE_ADD(item);
      const taxReduction = this.calculateTaxReduction(item);
      
      // For BH_INVOICE, don't add taxAmount to the total, only subtract taxReduction
      let totalAmount = baseAmount - discountAmount - taxReduction;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_BH_SEPARATE_DISPLAY(item) {
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      const chargeAmount = this.calculateChargeAmount_BH_SEPARATE_DISPLAY(item);
      const taxAmount = this.calculateTaxAmount_BH_SEPARATE_DISPLAY(item);
      const taxReduction = this.calculateTaxReduction(item);
      
      // For BH_INVOICE, don't add taxAmount to the total, only subtract taxReduction
      let totalAmount = baseAmount - discountAmount + chargeAmount - taxReduction;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_BH_ADD_SEPARATE(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_SEPARATE(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      const chargeAmount = this.calculateChargeAmount_BH_ADD_SEPARATE(item);
      const taxAmount = this.calculateTaxAmount_BH_ADD_SEPARATE(item);
      const taxReduction = this.calculateTaxReduction(item);
      
      // For BH_INVOICE, don't add taxAmount to the total, only subtract taxReduction
      let totalAmount = baseAmount + chargeAmount - taxReduction;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_BH_ADD_ADD(item) {
      const unitPriceWithDiscountAndCharge = this.calculateUnitPrice_BH_ADD_ADD(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceWithDiscountAndCharge;
      const taxAmount = this.calculateTaxAmount_BH_ADD_ADD(item);
      const taxReduction = this.calculateTaxReduction(item);
      
      // For BH_INVOICE, don't add taxAmount to the total, only subtract taxReduction
      let totalAmount = baseAmount - taxReduction;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    calculateTotalAmount_BH_ADD_DISPLAY(item) {
      const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_DISPLAY(item);
      const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
      const chargeAmount = this.calculateChargeAmount_BH_ADD_DISPLAY(item);
      const taxAmount = this.calculateTaxAmount_BH_ADD_DISPLAY(item);
      const taxReduction = this.calculateTaxReduction(item);
      
      // For BH_INVOICE, don't add taxAmount to the total, only subtract taxReduction
      let totalAmount = baseAmount + chargeAmount - taxReduction;
      totalAmount = this.roundTo(totalAmount, this.eInvoiceConfig.MinorUnit || 0);
      return totalAmount > 0 ? totalAmount : 0;
    },

    // === TOTAL BEFORE TAX CALCULATION ===
    calculateTotalBeforeTax(item) {
      if (!item || typeof item !== 'object' || (!(+item.Price > 0) || !(+item.DisplayUnitPrice > 0))) {
        return 0;
      }
      
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;
      
      // Xử lý đặc biệt cho trường hợp SEPARATE_ROW
      if (chargeOption === 'SEPARATE_ROW') {
        // Kiểm tra nếu là dòng phí riêng
        if (item.IsChargeRow) {
          // For charge rows, BeforeTaxAmount and SubAmount should be the Price
          // Đảm bảo BeforeTaxAmount và SubAmount luôn được set đúng
          item.BeforeTaxAmount = +item.Price || 0;
          item.SubAmount = +item.Price || 0;
          return +item.Price || 0;
        }
        
        // Đối với các dòng sản phẩm thông thường trong trường hợp SEPARATE_ROW
        if (discountOption === 'SEPARATE_COLUMN') {
          // Khi discount hiển thị riêng, đơn giá không thay đổi
          const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
          const discountAmount = (+item.DiscountAmount || 0);
          return baseAmount - discountAmount;
        } else if (discountOption === 'ADD_TO_UNIT_PRICE') {
          // Khi discount gộp vào đơn giá, đơn giá đã bị trừ
          // Lấy đơn giá đã trừ discount từ hàm calculateUnitPrice
          const unitPriceAfterDiscount = this.calculateUnitPrice(item);
          return (+item.Quantity || 1) * unitPriceAfterDiscount;
        }
      }
      
      // Luồng 1: VAT_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
        const discountAmount = (+item.DiscountAmount || 0);
        const chargeAmount = this.calculateChargeAmount_VAT_SEPARATE_SEPARATE(item);
        return baseAmount - discountAmount + chargeAmount;
      }
      
      // Luồng 2: VAT_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        const unitPriceWithCharge = this.calculateUnitPrice_VAT_SEPARATE_ADD(item);
        const baseAmount = (+item.Quantity || 1) * unitPriceWithCharge;
        const discountAmount = (+item.DiscountAmount || 0);
        return baseAmount - discountAmount;
      }
      
      // Luồng 3: VAT_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
        const discountAmount = (+item.DiscountAmount || 0);
        return baseAmount - discountAmount;
      }
      
      // Luồng 4: VAT_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_SEPARATE(item);
        const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
        const chargeAmount = this.calculateChargeAmount_VAT_ADD_SEPARATE(item);
        return baseAmount + chargeAmount;
      }
      
      // Luồng 5: VAT_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        const unitPriceWithDiscountAndCharge = this.calculateUnitPrice_VAT_ADD_ADD(item);
        return (+item.Quantity || 1) * unitPriceWithDiscountAndCharge;
      }
      
      // Luồng 6: VAT_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'VAT_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        const unitPriceAfterDiscount = this.calculateUnitPrice_VAT_ADD_DISPLAY(item);
        return (+item.Quantity || 1) * unitPriceAfterDiscount;
      }
      
      // Luồng 7: BH_INVOICE + SEPARATE_COLUMN + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'SEPARATE_COLUMN') {
        const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
        const discountAmount = (+item.DiscountAmount || 0);
        const chargeAmount = this.calculateChargeAmount_BH_SEPARATE_SEPARATE(item);
        return baseAmount - discountAmount + chargeAmount;
      }
      
      // Luồng 8: BH_INVOICE + SEPARATE_COLUMN + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        const unitPriceWithCharge = this.calculateUnitPrice_BH_SEPARATE_ADD(item);
        const baseAmount = (+item.Quantity || 1) * unitPriceWithCharge;
        const discountAmount = (+item.DiscountAmount || 0);
        return baseAmount - discountAmount;
      }
      
      // Luồng 9: BH_INVOICE + SEPARATE_COLUMN + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'SEPARATE_COLUMN' && chargeOption === 'DISPLAY_IN_TOTAL') {
        const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
        const discountAmount = (+item.DiscountAmount || 0);
        return baseAmount - discountAmount;
      }
      
      // Luồng 10: BH_INVOICE + ADD_TO_UNIT_PRICE + SEPARATE_COLUMN
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'SEPARATE_COLUMN') {
        const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_SEPARATE(item);
        const baseAmount = (+item.Quantity || 1) * unitPriceAfterDiscount;
        const chargeAmount = this.calculateChargeAmount_BH_ADD_SEPARATE(item);
        return baseAmount + chargeAmount;
      }
      
      // Luồng 11: BH_INVOICE + ADD_TO_UNIT_PRICE + ADD_TO_UNIT_PRICE
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'ADD_TO_UNIT_PRICE') {
        const unitPriceWithDiscountAndCharge = this.calculateUnitPrice_BH_ADD_ADD(item);
        return (+item.Quantity || 1) * unitPriceWithDiscountAndCharge;
      }
      
      // Luồng 12: BH_INVOICE + ADD_TO_UNIT_PRICE + DISPLAY_IN_TOTAL
      if (invoiceType === 'BH_INVOICE' && discountOption === 'ADD_TO_UNIT_PRICE' && chargeOption === 'DISPLAY_IN_TOTAL') {
        const unitPriceAfterDiscount = this.calculateUnitPrice_BH_ADD_DISPLAY(item);
        return (+item.Quantity || 1) * unitPriceAfterDiscount;
      }
      
      return 0;
    },

    // === TAX REDUCTION CALCULATION (BH_INVOICE only) ===
    calculateTaxReduction(item) {
      if (!item || this.eInvoiceConfig.InvoiceType !== 'BH_INVOICE' || (!(+item.Price > 0) || !(+item.DisplayUnitPrice > 0))) {
        return 0;
      }
      
      const taxAmount = this.calculateTaxAmount(item);
      const reductionPercent = (this.$ls_Invoices.length && this.$ls_Invoices[0].PercentTaxReduction) || 20;
      
      let reductionAmount = taxAmount * reductionPercent / 100;
      reductionAmount = this.roundTo(reductionAmount, this.eInvoiceConfig.MinorUnit || 0);
      return reductionAmount > 0 ? reductionAmount : 0;
    },

    // === INVERTED CALCULATION METHODS (for when user edits total amount) ===
    calculateInvertedUnitPrice(item) {
      // Tính ngược Price gốc từ TotalAmount dựa trên từng luồng riêng biệt
      if (!item || typeof item !== 'object') return 0;
      
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;
      
      // Xác định các minorUnit
      const priceMinorUnit = this.eInvoiceConfig?.PriceMinorUnit ?? 2;
      const minorUnit = this.eInvoiceConfig?.MinorUnit ?? 0;
      
      let unitPrice = 0;
      const totalAmount = +item.TotalAmount || 0;
      const quantity = +item.Quantity || 1;
      const taxRate = +item.Tax || 0;
      const chargeRate = +item.Charges || 0;
      const discountAmount = +item.DiscountAmount || 0;
      
      if (invoiceType === 'BH_INVOICE') {
        // Logic đặc biệt cho BH_INVOICE với tax reduction
        const reductionRate = (this.$ls_Invoices.length && this.$ls_Invoices[0].PercentTaxReduction) / 100 || 0.2;
        
        // Bước 1: Bỏ tax reduction để có total trước tax reduction
        let baseBeforeTax = totalAmount;
        if (taxRate > 0) {
          // totalAmount = baseBeforeTax + tax - taxReduction
          // totalAmount = baseBeforeTax + (baseBeforeTax * taxRate/100) - (baseBeforeTax * taxRate/100 * reductionRate)
          // totalAmount = baseBeforeTax * (1 + taxRate/100 * (1 - reductionRate))
          baseBeforeTax = totalAmount / (1 + (taxRate / 100) * (1 - reductionRate));
        }
        
        // Bước 2: Xử lý charge và discount dựa trên option
        if (chargeOption === 'SEPARATE_COLUMN' || chargeOption === 'DISPLAY_IN_TOTAL') {
          // Charge tính riêng
          if (chargeRate > 0) {
            if (discountOption === 'SEPARATE_COLUMN') {
              // baseBeforeTax = (Price * quantity - discount) + charge
              // baseBeforeTax = (Price * quantity - discount) * (1 + chargeRate/100)
              // => (Price * quantity - discount) = baseBeforeTax / (1 + chargeRate/100)
              // => Price * quantity = baseBeforeTax / (1 + chargeRate/100) + discount
              // => Price = (baseBeforeTax / (1 + chargeRate/100) + discount) / quantity
              const baseAfterDiscount = baseBeforeTax / (1 + chargeRate / 100);
              unitPrice = (baseAfterDiscount + discountAmount) / quantity;
            } else {
              // discountOption === 'ADD_TO_UNIT_PRICE'
              // baseBeforeTax = unitPriceAfterDiscount * quantity + charge
              // unitPriceAfterDiscount = Price - discountPerUnit
              // charge = unitPriceAfterDiscount * quantity * chargeRate/100
              // => baseBeforeTax = unitPriceAfterDiscount * quantity * (1 + chargeRate/100)
              // => unitPriceAfterDiscount = baseBeforeTax / (quantity * (1 + chargeRate/100))
              // => Price = unitPriceAfterDiscount + discountPerUnit
              const unitPriceAfterDiscount = baseBeforeTax / (quantity * (1 + chargeRate / 100));
              unitPrice = unitPriceAfterDiscount + (discountAmount / quantity);
            }
          } else {
            // Không có charge
            if (discountOption === 'SEPARATE_COLUMN') {
              // baseBeforeTax = Price * quantity - discount
              // => Price = (baseBeforeTax + discount) / quantity
              unitPrice = (baseBeforeTax + discountAmount) / quantity;
            } else {
              // discountOption === 'ADD_TO_UNIT_PRICE'
              // baseBeforeTax = unitPriceAfterDiscount * quantity
              // unitPriceAfterDiscount = Price - discountPerUnit
              // => Price = baseBeforeTax / quantity + discountPerUnit
              unitPrice = baseBeforeTax / quantity + (discountAmount / quantity);
            }
          }
        } else {
          // chargeOption === 'ADD_TO_UNIT_PRICE'
          // Charge đã gộp vào unit price
          if (discountOption === 'SEPARATE_COLUMN') {
            // baseBeforeTax = unitPriceWithCharge * quantity - discount
            // unitPriceWithCharge = Price + chargePerUnit
            // chargePerUnit = (Price * quantity - discount) * chargeRate/100 / quantity
            // => baseBeforeTax = (Price + chargePerUnit) * quantity - discount
            // Giải phương trình để tìm Price
            // baseBeforeTax + discount = (Price + chargePerUnit) * quantity
            // baseBeforeTax + discount = Price * quantity + chargePerUnit * quantity
            // baseBeforeTax + discount = Price * quantity + (Price * quantity - discount) * chargeRate/100
            // baseBeforeTax + discount = Price * quantity * (1 + chargeRate/100) - discount * chargeRate/100
            // => Price * quantity = (baseBeforeTax + discount + discount * chargeRate/100) / (1 + chargeRate/100)
            // => Price = (baseBeforeTax + discount * (1 + chargeRate/100)) / (quantity * (1 + chargeRate/100))
            if (chargeRate > 0) {
              unitPrice = (baseBeforeTax + discountAmount * (1 + chargeRate/100)) / (quantity * (1 + chargeRate/100));
            } else {
              unitPrice = (baseBeforeTax + discountAmount) / quantity;
            }
          } else {
            // discountOption === 'ADD_TO_UNIT_PRICE'
            // baseBeforeTax = unitPriceWithDiscountAndCharge * quantity
            // unitPriceWithDiscountAndCharge = Price - discountPerUnit + chargePerUnit
            // chargePerUnit = (Price - discountPerUnit) * chargeRate/100
            // => unitPriceWithDiscountAndCharge = (Price - discountPerUnit) * (1 + chargeRate/100)
            // => baseBeforeTax = (Price - discountPerUnit) * quantity * (1 + chargeRate/100)
            // => (Price - discountPerUnit) = baseBeforeTax / (quantity * (1 + chargeRate/100))
            // => Price = baseBeforeTax / (quantity * (1 + chargeRate/100)) + discountPerUnit
            if (chargeRate > 0) {
              const unitPriceAfterDiscount = baseBeforeTax / (quantity * (1 + chargeRate / 100));
              unitPrice = unitPriceAfterDiscount + (discountAmount / quantity);
            } else {
              unitPrice = baseBeforeTax / quantity + (discountAmount / quantity);
            }
          }
        }
      } else {
        // VAT_INVOICE và các loại invoice khác
        // Bước 1: Bỏ thuế
        let baseBeforeTax = totalAmount;
        if (taxRate > 0) {
          baseBeforeTax = totalAmount / (1 + taxRate / 100);
        }
        
        // Bước 2: Xử lý charge và discount dựa trên option
        if (chargeOption === 'SEPARATE_COLUMN' || chargeOption === 'DISPLAY_IN_TOTAL') {
          // Charge tính riêng
          if (chargeRate > 0) {
            if (discountOption === 'SEPARATE_COLUMN') {
              // baseBeforeTax = (Price * quantity - discount) + charge
              // charge = (Price * quantity - discount) * chargeRate/100
              // => baseBeforeTax = (Price * quantity - discount) * (1 + chargeRate/100)
              // => (Price * quantity - discount) = baseBeforeTax / (1 + chargeRate/100)
              // => Price = (baseBeforeTax / (1 + chargeRate/100) + discount) / quantity
              const baseAfterDiscount = baseBeforeTax / (1 + chargeRate / 100);
              unitPrice = (baseAfterDiscount + discountAmount) / quantity;
            } else {
              // discountOption === 'ADD_TO_UNIT_PRICE'
              // baseBeforeTax = unitPriceAfterDiscount * quantity + charge
              // charge = unitPriceAfterDiscount * quantity * chargeRate/100
              // => baseBeforeTax = unitPriceAfterDiscount * quantity * (1 + chargeRate/100)
              // => unitPriceAfterDiscount = baseBeforeTax / (quantity * (1 + chargeRate/100))
              // => Price = unitPriceAfterDiscount + discountPerUnit
              const unitPriceAfterDiscount = baseBeforeTax / (quantity * (1 + chargeRate / 100));
              unitPrice = unitPriceAfterDiscount + (discountAmount / quantity);
            }
          } else {
            // Không có charge
            if (discountOption === 'SEPARATE_COLUMN') {
              // baseBeforeTax = Price * quantity - discount
              unitPrice = (baseBeforeTax + discountAmount) / quantity;
            } else {
              // discountOption === 'ADD_TO_UNIT_PRICE'
              unitPrice = baseBeforeTax / quantity + (discountAmount / quantity);
            }
          }
        } else {
          // chargeOption === 'ADD_TO_UNIT_PRICE'
          if (discountOption === 'SEPARATE_COLUMN') {
            // baseBeforeTax = unitPriceWithCharge * quantity - discount
            // unitPriceWithCharge = Price + chargePerUnit
            // chargePerUnit = (Price * quantity - discount) * chargeRate/100 / quantity
            // Giải phương trình tương tự như BH_INVOICE
            if (chargeRate > 0) {
              unitPrice = (baseBeforeTax + discountAmount * (1 + chargeRate/100)) / (quantity * (1 + chargeRate/100));
            } else {
              unitPrice = (baseBeforeTax + discountAmount) / quantity;
            }
          } else {
            // discountOption === 'ADD_TO_UNIT_PRICE'
            if (chargeRate > 0) {
              const unitPriceAfterDiscount = baseBeforeTax / (quantity * (1 + chargeRate / 100));
              unitPrice = unitPriceAfterDiscount + (discountAmount / quantity);
            } else {
              unitPrice = baseBeforeTax / quantity + (discountAmount / quantity);
            }
          }
        }
      }
      
      // Làm tròn theo cấu hình
      unitPrice = this.roundTo(unitPrice, this.eInvoiceConfig.PriceMinorUnit || 2);
      
      return unitPrice > 0 ? unitPrice : 0;
    },

    calculateInvertedChargeAmount(item) {
      // Xác định minorUnit cho tiền phí
      const minorUnit = this.eInvoiceConfig?.MinorUnit ?? 0;
      
      let res = (+item.TotalAmount || 0) * (+item.Charges || 0) / 100 / ((1 + (+item.Charges || 0) / 100) * (1 + (+item.Tax || 0) / 100));
      res = this.roundTo(res, minorUnit);
      return res > 0 ? res : 0;
    },

    calculateInvertedTaxAmount(item) {
      // Xác định minorUnit cho tiền thuế
      const minorUnit = this.eInvoiceConfig?.MinorUnit ?? 0;
      
      let res = (+item.TotalAmount || 0) * (+item.Tax || 0) / 100 / (1 + (+item.Tax || 0) / 100);
      res = this.roundTo(res, minorUnit);
      return res > 0 ? res : 0;
    },

    // Thêm vào methods
    getItemsByChargeRate(chargeRate) {
      if (!Array.isArray(this.items)) return [];
      return this.items.filter(item =>
        (item.Charges || 0) === chargeRate && 
        (this.isAutoCalculateMoney ? (item.PreChargesAmount > 0) : (item.ChargesAmount > 0))
      );
    },

    // Thêm method tính tổng tiền trước khi áp dụng charge
    calculateTotalBeforeCharge(item) {
      const discountAmount = this.showDiscountColumn() ? item.DiscountAmount : 0;
      let result = +this.calculateUnitPrice(item) * +item.Quantity - discountAmount;
      return result > 0 ? result : 0;
    },

    // Thêm method kiểm tra hiển thị charge tại total section
    showChargeAtTotalSection() {
      return this.eInvoiceConfig.ChargeOption === 'DISPLAY_IN_TOTAL';
    },
    
    // Thêm vào methods hiện có
    getItemsByTaxRate(taxRate) {
      if (!Array.isArray(this.items)) return [];
      // Lấy tất cả các item có cùng tax rate, bao gồm cả charge rows
      return this.items.filter(item =>
        (item.Tax || 0) === taxRate && 
        (this.isAutoCalculateMoney ? (item.PreTaxAmount > 0) : (item.TaxAmount > 0))
      );
    },
    sumByField(list, prop = '') {
      if (!Array.isArray(list)) return 0;
      return list.reduce((acc, entry) => {
        if (prop) {
          // Trường hợp đặc biệt: DisplayUnitPrice và Price cần nhân với số lượng
          if (prop === 'DisplayUnitPrice' || prop === 'Price') {
            // Lấy số lượng từ item, đảm bảo là số, mặc định là 1 nếu không có
            const quantity = +entry['Quantity'] || 1;
            // Nhân với đơn giá trước khi cộng tổng
            return acc + ((+entry[prop] || 0) * quantity);
          } 
          // Các trường hợp khác: cộng trực tiếp
          return acc + (+entry[prop] || 0);
        }
        return acc + (+entry || 0);
      }, 0);
    },

    sumWithCallback(list, cb) {
      if (!Array.isArray(list)) return 0;
      
      // Đặc biệt xử lý cho trường hợp calculateTotalBeforeTax khi chargeOption là 'ADD_TO_UNIT_PRICE' hoặc 'SEPARATE_ROW'
      if (cb === this.calculateTotalBeforeTax) {
        const chargeOption = this.eInvoiceConfig.ChargeOption;
        if (chargeOption === 'ADD_TO_UNIT_PRICE' || chargeOption === 'SEPARATE_ROW') {
          // Đảm bảo tính đúng total taxable amount cho các item trong cùng nhóm
          return list.reduce((total, item) => {
            return total + +this.calculateTotalBeforeTax(item);
          }, 0);
        }
      }
      
      // Xử lý bình thường cho các trường hợp khác
      return list.reduce((total, item) => {
        return total + +cb(item);
      }, 0)
    },

    // Helper method to calculate SubAmount and BeforeTaxAmount for an item
    calculateSubAmount(item) {
      if (item.IsChargeRow) {
        // For charge rows, SubAmount should be the Price
        return +item.Price || 0;
      } else {
        // For regular items, SubAmount is quantity * unit price - discount
        const quantity = +item.Quantity || 0;
        const unitPrice = +item.Price || 0;
        const baseAmount = quantity * unitPrice;
        
        // Apply discount if any
        const discountAmount = +item.DiscountAmount || 0;
        const amountAfterDiscount = baseAmount - discountAmount;
        
        const chargeOption = this.eInvoiceConfig?.ChargeOption || '';
        let chargeAmount = 0;

        if (chargeOption === 'SEPARATE_COLUMN' || chargeOption === 'DISPLAY_IN_TOTAL') {
          if (this.isAutoCalculateMoney) {
            chargeAmount = this.calculateChargeAmount(item);
          } else {
            chargeAmount = +item.ChargesAmount || 0;
          }
        }

        const minorUnit = this.eInvoiceConfig?.MinorUnit ?? 0;
        const result = amountAfterDiscount + chargeAmount;
        return this.roundTo(result, minorUnit);
      }
    },

    // Helper method to update SubAmount and BeforeTaxAmount for an item
    updateSubAmountAndBeforeTaxAmount(item) {
      const subAmount = this.calculateSubAmount(item);
      item.SubAmount = subAmount;
      item.BeforeTaxAmount = subAmount;
      return subAmount;
    },

    getItemsDetail() {
      // Check if any items are actually grouped (have GroupItemId)
      const hasGroupedItems = this.items.some(item => item.GroupItemCustomId);
      
      // Ensure all items have SubAmount and BeforeTaxAmount properly calculated
      const processedItems = this.items.map(item => {
        const processedItem = { ...item };
        
        // Use helper method to calculate and set SubAmount and BeforeTaxAmount
        this.updateSubAmountAndBeforeTaxAmount(processedItem);
        
        return processedItem;
      });
      
      // Include grouping flag along with processed items
      return {
        items: processedItems,
        isGrouped: hasGroupedItems // true if any items have GroupItemId
      };
    },

    fillItemsDetail(items) {
      console.log('fillItemsDetail called', {
        actionType: this.actionType,
        typeDisplay: this.typeDisplay,
        itemsLength: items.length
      });
      
      // Clear existing data first
      this.items.length = 0;
      this.groupedItems = [];
      
      // Special handling for view_detail mode to avoid double processing
      // if (this.typeDisplay === 'view_detail') {
      //   // In view_detail mode, just use items as-is with minimal processing
      //   this.items = items.map(item => {
      //     return {
      //       ...item,
      //       // Keep the original values for display
      //       PreChargesAmount: item.ChargesAmount,
      //       PreTaxAmount: item.TaxAmount,
      //       PreTotalAmount: item.TotalAmount,
      //       DisplayUnitPrice: item.Price || 0,

      //       GroupItemCustomId: item.GroupItemCustomId || null,
      //       GroupItemCustomName: item.GroupItemCustomName || '',

      //       isAdded: true,
      //       isChecked: false
      //     };
      //   });
        
      //   // Create a single flat group with all items for view_detail mode
      //   this.groupedItems = [{ 
      //     id: 'flat_view', 
      //     title: '', 
      //     items: this.items 
      //   }];
        
      //   // Update pagination directly without additional grouping
      //   this.totalPagination.TotalRecord = this.items.length;
      //   this.totalPagination.TotalPage = Math.ceil(
      //     this.totalPagination.TotalRecord / this.paging.PageSize,
      //   );
        
      //   // Set up paging without grouping
      //   this.getPagingItems();
      //   this.getPagingItemGroup();
        
      //   console.log('fillItemsDetail completed for view_detail mode');
      //   return; // Exit early for view_detail mode
      // }
      
      // Normal mode processing for non-view_detail cases
      this.items = items.map(item => {
        const newItem = {
          ...item,
          // Use existing pre-values if provided, otherwise initialize them
          PreChargesAmount: item.PreChargesAmount || item.ChargesAmount,
          PreTaxAmount: item.PreTaxAmount || item.TaxAmount,
          PreTotalAmount: item.PreTotalAmount || item.TotalAmount,
          AfterTaxAmount: item.AfterTaxAmount || item.TotalAmount,
          DisplayUnitPrice: item.DisplayUnitPrice || this.calculateUnitPrice(item) || item.Price,

          GroupItemCustomId: item.GroupItemCustomId || null,
          GroupItemCustomName: item.GroupItemCustomName || '',
          GroupUnitName: item.GroupUnitName || '',

          isAdded: true,
          isChecked: false
        };
        // Tính TaxReduction43Amount nếu là BH_INVOICE và giá trị từ API bằng 0
        if (this.isBHInvoice && !(+newItem.TaxReduction43Amount > 0)) {
          newItem.TaxReduction43Amount = this.calculateTaxReduction(newItem);
          newItem.PreTaxReduction43Amount = newItem.TaxReduction43Amount;
        }
        return newItem;
      });
      
      // Update store for non-view_detail mode
      // this.$store.commit('eInvoiceManagement/UPDATE_FILLED_ITEMS', items);
      // this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', this.items);
      
      // Setup pagination
      this.totalPagination.TotalRecord = this.items.length;
      this.totalPagination.TotalPage = Math.ceil(
        this.totalPagination.TotalRecord / this.paging.PageSize,
      );
      
      // Only set selectedGroupOption if not in adjust mode
      if (this.actionType !== INVOICE_ACTION.ADJUST_INCREASE_INVOICE && 
          this.actionType !== INVOICE_ACTION.ADJUST_DECREASE_INVOICE &&
          this.actionType !== INVOICE_ACTION.REPLACE_INVOICE &&
          this.actionType !== INVOICE_ACTION.CHANGE_INVOICE &&
          this.actionType !== INVOICE_ACTION.ADJUST_INVOICE &&
          this.actionType !== INVOICE_ACTION.ADJUST_INVOICE_INFORMATION &&
          this.actionType !== INVOICE_ACTION.ADJUST_INVOICE_VALUE &&
          this.actionType !== INVOICE_ACTION.ADD_INVOICE) {  // Add this line
        this.selectedGroupOption = 'GroupItemId';
      }
      
      // Process groups and pagination for normal mode
      this.groupedItems = this.initialGroupItems(this.items);
      this.getPagingItems();
      this.getPagingItemGroup();
    },

    initialGroupItems(items) {
      const nonGroupItems = []; 
      const groupedMap = new Map(); 
      
      items.forEach(item => {
        // If item doesn't have GroupItemCustomId, add to nonGroupItems
        if (item.GroupItemCustomId == null || item.GroupItemCustomId === '') {
          nonGroupItems.push(item);
          return;
        }
        
        // If we have a GroupItemCustomId, add to or create a group
        if (!groupedMap.has(item.GroupItemCustomId)) {
          // Get properly formatted title from GroupItemCustomName
          const groupTitle = item.GroupItemCustomName || 'Nhóm mới';
          const groupUnitName = item.GroupUnitName || this.$t('common_unit_default');
          // Create group object with basic properties
          const newGroup = {
            id: item.GroupItemCustomId,
            title: groupTitle,
            specialTax: item.SpecialTax || 0,
            tax: item.Tax || 0,
            charges: item.Charges || 0,
            items: [item],
            type: item.GroupItemCustomName || 'default',
            unitName: groupUnitName,
            isCustomGroup: true
          };
          
          // Use Vue's reactive properties for collapsed state
          this.$set(newGroup, 'isCollapsed', false);
          this.$set(newGroup, 'isChecked', false);
          
          groupedMap.set(item.GroupItemCustomId, newGroup);
        } else {
          // Add to existing group
          const group = groupedMap.get(item.GroupItemCustomId);
          group.items.push(item);
        }
      });
      
      // Convert map values to array
      const grouped = Array.from(groupedMap.values());
      
      // Filter out empty groups
      const validGroups = grouped.filter(group => group.items.length > 0);
      
      // Create the nonGroup with Vue reactivity
      const nonGroup = { 
        id: uuidv4(), 
        title: 'NonGroup', 
        items: nonGroupItems, 
        isNonGroup: true,
        isCustomGroup: false
      };
      
      // Use Vue's reactive property for nonGroup collapsed state
      this.$set(nonGroup, 'isCollapsed', false);
      this.$set(nonGroup, 'isChecked', false);
      
      // Return both grouped items and nonGroup
      return [...validGroups, nonGroup];
    },
    
    getGroupPercent(list, prop = '') {
      if (!Array.isArray(list)) return;
      const setPercent = new Set(list.map(entry => +entry[prop]));
      const setPercentSize = setPercent.size;
      if (setPercentSize !== 1) return;

      return setPercent.values().next().value;
    },

    changePage(paging) {
      this.paging = paging;
      this.getPagingItems();
      this.getPagingItemGroup();
    },

    //Get total in e-invoice
    getTotalData() {
      return {
        TaxAmount: this.sumByField(this.items, 'TaxAmount'),
        ServicesCharge: this.sumByField(this.items, 'ChargesAmount'),
        DiscountAmount: this.sumByField(this.items, 'DiscountAmount'),
        AfterTaxAmount: this.sumByField(this.items, 'TotalAmount'), // TotalAmount
        BeforeTaxAmount: this.sumByField(this.items, 'BeforeTaxAmount')
        //BeforeTaxAmount: this.sumWithCallback(this.items, this.calculateTotalBeforeTax)
      }
    },

    async getEConfig() {
      try {
        const res = await getEInvoiceConfiguration();
        if (res.StatusCode === '200') {
          // Lấy cấu hình từ API
          const apiConfig = res.Data.EInvoiceConfig;
          
          // Xác định loại hóa đơn
          const invoiceType = apiConfig.InvoiceType || 'VAT_INVOICE';
          
          // Lấy cấu hình mặc định dựa trên loại hóa đơn
          const defaultConfig = this.defaultConfigs[invoiceType] || this.defaultConfigs.VAT_INVOICE;
          
          // Gộp cấu hình từ API và cấu hình mặc định, ưu tiên các giá trị từ API
          this.eInvoiceConfig = {
            ...defaultConfig,
            ...apiConfig,
            // Đảm bảo InvoiceType luôn đúng
            InvoiceType: invoiceType
          };
          
          // Cập nhật vào store
          this.$store.commit('eInvoiceManagement/UPDATE_EINVOICE_CONFIG', this.eInvoiceConfig);
          
        }
      } catch (error) {
        console.error('Error loading eInvoice configuration:', error);
        
        // Nếu có lỗi, sử dụng cấu hình mặc định VAT_INVOICE
        this.eInvoiceConfig = { ...this.defaultConfigs.VAT_INVOICE };
        this.$store.commit('eInvoiceManagement/UPDATE_EINVOICE_CONFIG', this.eInvoiceConfig);
      }
    },

    getPagingItems() {
      const start = (this.paging.PageIndex - 1) * this.paging.PageSize;
      const end = start + this.paging.PageSize;

      this.pagingItems = this.items.slice(start, end);
      this.totalPagination.TotalRecord = this.items.length;
      this.totalPagination.TotalPage = Math.ceil(
        this.totalPagination.TotalRecord / this.paging.PageSize,
      );
    },

    getPagingItemGroup() {
      // Normal processing for non-view_detail mode
      const result = [];

      this.totalPagination.TotalRecord = this.items.length;
      this.totalPagination.TotalPage = Math.ceil(
        this.totalPagination.TotalRecord / this.paging.PageSize,
      );

      // Validate data before rendering to avoid duplicate keys
      this.validateAndCleanData();

      let count = 0;
      const pageStart = (this.paging.PageIndex - 1) * this.paging.PageSize;
      const pageEnd = pageStart + this.paging.PageSize;
      for (const entry of this.groupedItems) {
        if (count >= pageEnd) break;

        const remaining = pageEnd - count;
        //Check if item is a group or just item not in a group
        if (Array.isArray(entry.items)) {
          const slicedItems = entry.items.slice(
            Math.max(0, pageStart - count),
            Math.max(0, pageStart - count) + remaining
          )

          if (slicedItems.length) {
            result.push({ ...entry, items: slicedItems });
          }

          count += entry.items.length;
        } else {
          if (count >= pageStart && count < pageEnd) {
            result.push(entry)
          }
          count++
        }
      }

      this.pagingGroupItems = result;

      if (this.isCheckedAll) {
        this.isCheckedAll = true;
        this.selectAll();
      }
      // Group that is checked in list
      const groupsIsChecked = this.groupedItems.filter(group => group.isChecked);
      if (groupsIsChecked.length > 0) {
        groupsIsChecked.map(group => {
          this.selectAllInGroup(group);
        })
      }
    },

    selectAll() {
      // Store the current toggle state from user action
      const newCheckedState = this.isCheckedAll;
      
      if (!newCheckedState) {
        this.selectedItems = [];
      }
      
      // Apply the state to all applicable items
      this.items.forEach(item => {
        // Don't select charge rows
        if (!item.IsChargeRow) {
          item.isChecked = newCheckedState;
        } else {
          item.isChecked = false;
        }
      });
      
      // Update group checkboxes - DIRECTLY SET to the new state
      this.groupedItems.forEach(group => {
        // Simply set group checkbox to match the main checkbox state
        this.$set(group, 'isChecked', newCheckedState);
        
        // Update all items in the group
        group.items.forEach(item => {
          if (!item.IsChargeRow) {
            item.isChecked = newCheckedState;
          }
        });
      });
      
      // Update paging group checkboxes
      this.pagingGroupItems.forEach(group => {
        // Simply set group checkbox to match the main checkbox state
        this.$set(group, 'isChecked', newCheckedState);
      });
      
      // Make sure selectedItems is updated correctly
      if (newCheckedState) {
        this.selectedItems = this.items.filter(item => !item.IsChargeRow);
      } else {
        this.selectedItems = [];
      }
    },

    selectAllInGroup(group) {
      const groupToCheck = this.groupedItems.find(el => el.id === group.id);
      // Only set group.isChecked if all non-charge items in the group are checked
      const nonChargeItems = groupToCheck.items.filter(item => !item.IsChargeRow);
      groupToCheck.isChecked = nonChargeItems.length > 0 && group.isChecked;
      
      groupToCheck.items.forEach(item => {
        // Skip charge rows when selecting all in a group
        if (!item.IsChargeRow) {
          item.isChecked = groupToCheck.isChecked;
          this.selectItem(group, item);
        } else {
          item.isChecked = false;
        }
      })
      
      this.$nextTick(() => {
        // Only consider non-charge rows when determining if all items are checked
        const allNonChargeItems = this.items.filter(item => !item.IsChargeRow);
        this.isCheckedAll = allNonChargeItems.length > 0 && allNonChargeItems.every(item => item.isChecked === true) && groupToCheck.isChecked;
      })
    },

    selectItem(group, item) {
      // Prevent selecting charge rows
      if (item.IsChargeRow) {
        item.isChecked = false;
        return;
      }
      
      if (!item.isChecked) {
        this.isCheckedAll = false;
      }
      if (group.isChecked && !item.isChecked) {
        group.isChecked = false;
      }
      if (this.isCheckedAll && !item.isChecked) {
        this.isChecked = false;
      }
      this.$nextTick(() => {
        if (item.isChecked) {
          this.selectedItems.push(item);
        } else {
          this.selectedItems = this.selectedItems.filter(el => el !== item);
        }
        // Only consider non-charge rows when determining if all items in a group are checked
        const nonChargeItems = group.items.filter(el => !el.IsChargeRow);
        group.isChecked = nonChargeItems.length > 0 && nonChargeItems.every(el => el.isChecked === true);
        
        // Only consider non-charge rows when determining if all items are checked
        const allNonChargeItems = this.items.filter(item => !item.IsChargeRow);
        this.isCheckedAll = allNonChargeItems.length > 0 && allNonChargeItems.every(item => item.isChecked === true);
        
        this.isCheckedAll = this.groupedItems.every(group => {
          const groupNonChargeItems = group.items.filter(item => !item.IsChargeRow);
          return groupNonChargeItems.length > 0 ? groupNonChargeItems.every(item => item.isChecked) : true;
        })
      })
    },
    addItem() {

    },
    setEditing(rowIndex, fieldName) {
      // Prevent editing in view_detail mode
      if (this.typeDisplay === 'view_detail') {
        return;
      }
      
      // Find the item by ItemId to check if it's a charge row
      const item = this.items.find(item => item.ItemId === rowIndex);
      
      // If it's a charge row, show notification and don't allow editing
      if (item && item.IsChargeRow) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('information'),
            text: 'Dòng phí riêng không thể chỉnh sửa trực tiếp. Vui lòng chỉnh sửa sản phẩm/dịch vụ gốc.',
            variant: 'info',
          },
        });
        return;
      }
      
      this.editingCell = { row: rowIndex, field: fieldName };
      // Sử dụng nextTick để focus vào ô input sau khi DOM đã được cập nhật
      this.$nextTick(() => {
        try {
          const refName = 'inputField-' + rowIndex;  // Lấy ref động theo chỉ số hàng
          const inputField = this.$refs[refName];
          // Kiểm tra nếu ref tồn tại và focus vào nó
          if (inputField && inputField[0]) {
            inputField[0].focus();  // Lấy phần tử đầu tiên từ mảng và focus
          } else if (inputField) {
            inputField.focus();
          }
        } catch (err) {
          console.log(err);
          this.editingCell = { row: null, field: null };
        }
      });
    },
    setEditingCollapse(rowIndex, fieldName, id) {
      // Prevent editing in view_detail mode
      if (this.typeDisplay === 'view_detail') {
        return;
      }
      
      this.editingCell = { row: rowIndex - id, field: fieldName };
      // Sử dụng nextTick để focus vào ô input sau khi DOM đã được cập nhật
      this.$nextTick(() => {
        const refName = 'inputField-' + (rowIndex - id);  // Lấy ref động theo chỉ số hàng
        const inputField = this.$refs[refName];
        // Kiểm tra nếu ref tồn tại và focus vào nó
        if (inputField && inputField[0]) {
          inputField[0].focus();  // Lấy phần tử đầu tiên từ mảng và focus
        } else if (inputField) {
          inputField.focus();
        }
      });
    },

    validateMoneyFields(item) {
      if (!item || typeof item !== 'object') return item;
      
      // Danh sách các trường tiền tệ cần kiểm tra
      const moneyFields = [
        'Price', 'DisplayUnitPrice', 'DiscountAmount', 
        'Charges', 'ChargesAmount', 'Tax', 'TaxAmount', 
        'TotalAmount', 'TaxReduction43Amount'
      ];
      
      // Với mỗi trường, nếu undefined hoặc NaN thì gán bằng 0
      moneyFields.forEach(field => {
        if (item[field] === undefined || item[field] === null || isNaN(+item[field])) {
          item[field] = 0;
        } else {
          // Đảm bảo giá trị là số
          item[field] = +item[field];
        }
      });
      
      // Đảm bảo Quantity không bao giờ là 0 (tránh chia cho 0)
      if (item.Quantity === undefined || item.Quantity === null || isNaN(+item.Quantity) || +item.Quantity <= 0) {
        item.Quantity = 1;
      }
      
      return item;
    },

    saveEdit(value = null, rowIndex, item, fieldName, event = null) {
      if (!item || typeof item !== 'object') return;
      
      // Prevent editing charge rows
      if (item.IsChargeRow) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('information'),
            text: 'Dòng phí riêng không thể chỉnh sửa trực tiếp. Vui lòng chỉnh sửa sản phẩm/dịch vụ gốc.',
            variant: 'info',
          },
        });
        // Reset editing state
        this.editingCell = { row: null, field: null };
        return;
      }
      
      let cellUpdateValue = value !== null ? value : (event?.target?.value || 0);
      cellUpdateValue = isNaN(+cellUpdateValue) ? 0 : +cellUpdateValue;
      
      // Kiểm tra nghiệp vụ điều chỉnh tăng/giảm
      if (this.actionType === INVOICE_ACTION.ADJUST_INCREASE_INVOICE) {
        if (+cellUpdateValue - (+item[fieldName] || 0) < 0) {
          showToast('warning', 'only_increase_adjustment');
          return;
        }
      } else if (this.actionType === INVOICE_ACTION.ADJUST_DECREASE_INVOICE) {
        if (+cellUpdateValue - (+item[fieldName] || 0) > 0) {
          showToast('success', 'only_decrease_adjustment');
          return;
        }
      }
      
      // Lưu lại các giá trị gốc để so sánh sau khi tính toán
      const originalDisplayUnitPrice = item.DisplayUnitPrice;
      
      // Cập nhật giá trị theo loại trường
      if (fieldName === 'ItemName' || fieldName === 'UnitName') {
        // Với trường text, cập nhật trực tiếp
        item[fieldName] = cellUpdateValue;
      } else if (fieldName === 'Price') {
        // Khi user edit cột đơn giá, đó là edit DisplayUnitPrice (giá hiển thị)
        item.DisplayUnitPrice = +cellUpdateValue;
        
        // Đồng bộ Price với DisplayUnitPrice để các calculation hoạt động đúng
        // Trong hầu hết trường hợp, Price sẽ bằng DisplayUnitPrice 
        // trừ khi có discount/charge gộp vào đơn giá
        item.Price = +cellUpdateValue;
      } else {
        // Với các trường số khác, cập nhật giá trị số
        item[fieldName] = +cellUpdateValue;
      }
      
      // Khi auto calculate bật, tính lại các giá trị liên quan
      if (this.isAutoCalculateMoney) {
        if (['DiscountAmount', 'Quantity', 'Charges', 'Price'].includes(fieldName)) {
          // Cập nhật SubAmount và BeforeTaxAmount trước khi tính các giá trị khác
          this.updateSubAmountAndBeforeTaxAmount(item);
          
          // Xử lý logic cho từng trường cụ thể
          if (fieldName === 'DiscountAmount') {
            // Khi DiscountAmount thay đổi, không tính lại DisplayUnitPrice 
            // vì DisplayUnitPrice hiển thị giá sau khi đã áp dụng discount/charge
            // và được user edit trực tiếp
          } else if (fieldName === 'Price') {
            // Khi user edit DisplayUnitPrice (qua fieldName = 'Price')
            // DisplayUnitPrice và Price đã được sync ở trên
            // Không cần tính lại DisplayUnitPrice
          } else if (fieldName === 'Quantity') {
            // Khi thay đổi số lượng, không ảnh hưởng đến đơn giá hiển thị
          } else if (fieldName === 'Charges') {
            // Khi thay đổi %charge, không tính lại DisplayUnitPrice
            // vì DisplayUnitPrice là giá mà user nhập trực tiếp
          }
          
          // Tính lại các giá trị tiền tệ
          item.ChargesAmount = this.calculateChargeAmount(item);
          item.TaxAmount = this.calculateTaxAmount(item);
          item.TotalAmount = this.calculateTotalAmount(item);
          item.AfterTaxAmount = item.TotalAmount;
          if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
            item.TaxReduction43Amount = this.calculateTaxReduction(item);
          }
          
          // Lưu các giá trị để so sánh
          item.PreChargesAmount = item.ChargesAmount;
          item.PreTaxAmount = item.TaxAmount;
          item.PreTotalAmount = item.TotalAmount;
        } else if (fieldName === 'Tax') {
          // Cập nhật SubAmount và BeforeTaxAmount khi thuế thay đổi
          this.updateSubAmountAndBeforeTaxAmount(item);
          
          // Khi thay đổi thuế, chỉ tính lại thuế và tổng tiền
          item.TaxAmount = this.calculateTaxAmount(item);
          item.TotalAmount = this.calculateTotalAmount(item);
          item.AfterTaxAmount = item.TotalAmount;
          if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
            item.TaxReduction43Amount = this.calculateTaxReduction(item);
          }
          
          // Lưu các giá trị để so sánh
          item.PreChargesAmount = item.ChargesAmount;
          item.PreTaxAmount = item.TaxAmount;
          item.PreTotalAmount = item.TotalAmount;
        } else if (fieldName === 'TotalAmount') {
          // Khi thay đổi tổng tiền, tính ngược Price gốc trước, sau đó tính lại DisplayUnitPrice
          
          // Lưu lại giá trị TotalAmount mà user vừa nhập
          const userInputTotalAmount = +cellUpdateValue;
          
          // Bước 1: Tính ngược Price gốc từ TotalAmount
          const invertedUnitPrice = this.calculateInvertedUnitPrice(item);
          item.Price = invertedUnitPrice;
          
          // Cập nhật SubAmount và BeforeTaxAmount sau khi có Price mới
          this.updateSubAmountAndBeforeTaxAmount(item);
          
          // Bước 2: Từ Price gốc, tính lại DisplayUnitPrice theo các option
          item.DisplayUnitPrice = this.calculateUnitPrice(item);
          
          // Bước 3: Tính lại các giá trị tiền tệ từ Price gốc đã được cập nhật
          item.ChargesAmount = this.calculateChargeAmount(item);
          item.TaxAmount = this.calculateTaxAmount(item);
          
          // Bước 4: Đảm bảo TotalAmount luôn giữ nguyên giá trị user nhập vào
          item.TotalAmount = userInputTotalAmount;
          item.AfterTaxAmount = item.TotalAmount;
          if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
            item.TaxReduction43Amount = this.calculateTaxReduction(item);
          }
            // Force the TotalAmount to be exactly what the user entered

          // Lưu các giá trị để so sánh
          item.PreChargesAmount = item.ChargesAmount;
          item.PreTaxAmount = item.TaxAmount;
          item.PreTotalAmount = item.TotalAmount;

          item.TotalAmount = userInputTotalAmount;
          item.PreTotalAmount = userInputTotalAmount;
        }
      }
      
      // Kết thúc chỉnh sửa
      this.editingCell = { row: null, field: null };
    },

    preventEditAdjustIncreaseOrDecrease(adjustType, oldVal, newVal, event) {
      if (typeof oldVal !== 'number' && typeof newVal !== 'number') return;

      const value = newVal - oldVal;
      if (adjustType === 'increase') {
        if (value < 0) return 0;
        else return 1;
      }

      if (adjustType === 'decrease') {
        if (value > 0) return 0;
        else return 1;
      }
    },
    isEditing(rowIndex, fieldName) {
      return this.editingCell.row === rowIndex && this.editingCell.field === fieldName;
    },
    isGroupNameEditing(groupId) {
      return groupId === this.editingGroupName;
    },
    isGroupUnitNameEditing(groupId) {
      return groupId === this.editingGroupUnitName;
    },
    setEditingGroupName(groupId) {
      // Prevent editing group name in view_detail mode
      if (this.typeDisplay === 'view_detail') {
        return;
      }
      
      this.editingGroupName = groupId;
    },
    setEditingGroupUnitName(groupId) {
      // Prevent editing group name in view_detail mode
      if (this.typeDisplay === 'view_detail') {
        return;
      }
      
      this.editingGroupUnitName = groupId;
    },
    saveEditingGroupName() {
      const editedGroup = this.groupedItems.find(group => group.id === this.editingGroupName);
      
      if (editedGroup) {
        // Get the new group title from the edited group
        const newGroupName = editedGroup.title;

        const pagingGroup = this.pagingGroupItems.find(g => g.id === editedGroup.id);
        if (pagingGroup) {
          console.log('Updating pagingGroup items:', pagingGroup.items.length);
          pagingGroup.items.forEach(item => {
            item.GroupItemCustomName = pagingGroup.title;
          });
        }
        
        editedGroup.items.forEach(item => {
          item.GroupItemCustomName = pagingGroup.title;
        });
        
        let updatedCount = 0;
        this.items.forEach(item => {
          if (item.GroupItemCustomId === editedGroup.id) {
            item.GroupItemCustomName = pagingGroup.title;
            updatedCount++;
          }
        });
        
        this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', [...this.items]);
      } else {
        console.error('Could not find group with ID:', this.editingGroupName);
      }
      
      this.editingGroupName = '';
    },

    saveEditingGroupUnitName() {
      const editedGroup = this.groupedItems.find(group => group.id === this.editingGroupUnitName);
      
      if (editedGroup) {
        // Get the new group title from the edited group
        const newGroupUnitName = editedGroup.unitName;

        const pagingGroup = this.pagingGroupItems.find(g => g.id === editedGroup.id);
        if (pagingGroup) {
          console.log('Updating pagingGroup items:', pagingGroup.items.length);
          if (pagingGroup.unitName === '' || pagingGroup.unitName === null){
            pagingGroup.unitName = editedGroup.unitName;
          }
          pagingGroup.items.forEach(item => {
            item.GroupUnitName = pagingGroup.unitName;
          });
        }
        
        editedGroup.items.forEach(item => {
          item.GroupUnitName = pagingGroup.unitName;
        });
        
        let updatedCount = 0;
        this.items.forEach(item => {
          if (item.GroupItemCustomId === editedGroup.id) {
            item.GroupUnitName = pagingGroup.unitName;
            updatedCount++;
          }
        });
        
        this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', [...this.items]);
      } else {
        console.error('Could not find group with ID:', this.editingGroupUnitName);
      }
      
      this.editingGroupUnitName = '';
    },

    // === POPUP EDITING METHODS ===
    openItemEditPopup(item) {
      // Nếu đang ở chế độ xem chi tiết thì không mở popup
      if (this.typeDisplay === 'view_detail') return;
      
      // Check if this is a charge row - if so, show a notification and don't open popup
      if (item.IsChargeRow) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('information'),
            text: 'Dòng phí riêng không thể chỉnh sửa trực tiếp. Vui lòng chỉnh sửa sản phẩm/dịch vụ gốc.',
            variant: 'info',
          },
        });
        return;
      }
      
      // Lưu lại item được chọn
      this.selectedEditItem = { ...item };
      
      // Đảm bảo rằng item có thông tin về cấu hình
      this.selectedEditItem.InvoiceType = this.eInvoiceConfig.InvoiceType;
      
      // Gọi phương thức showModal của ItemEditPopup, popup sẽ tự động tạo item clone
      // và áp dụng cấu hình theo loại hóa đơn
      this.$nextTick(() => {
        this.$refs.itemEditPopup.showModal(this.selectedEditItem);
      });
    },

    saveItemFromPopup(editedItem) {
      // Tìm item gốc trong danh sách
      const originalItem = this.items.find(item => item.ItemId === editedItem.ItemId);
      if (!originalItem) return;
      
      // Cập nhật các trường đã chỉnh sửa - dữ liệu thực của item
      originalItem.ItemName = editedItem.ItemName;
      originalItem.UnitName = editedItem.UnitName;
      originalItem.Quantity = +editedItem.Quantity || 0;
      originalItem.Price = +editedItem.Price || 0;
      originalItem.DiscountAmount = +editedItem.DiscountAmount || 0;
      originalItem.Charges = +editedItem.Charges || 0;
      originalItem.Tax = +editedItem.Tax || 0;
      
      // Calculate and update SubAmount and BeforeTaxAmount using helper method
      this.updateSubAmountAndBeforeTaxAmount(originalItem);
      
      // Lưu trực tiếp các giá trị đã tính toán từ popup
      originalItem.ChargesAmount = +editedItem.ChargesAmount || 0;
      originalItem.TaxAmount = +editedItem.TaxAmount || 0;
      originalItem.TotalAmount = +editedItem.TotalAmount || 0;
      originalItem.AfterTaxAmount = +editedItem.TotalAmount || 0;
      if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
        originalItem.TaxReduction43Amount = +editedItem.TaxReduction43Amount || 0;
      }
      
      if (this.isAutoCalculateMoney) {
        // Tính toán lại các giá trị hiển thị theo công thức
        const calculatedChargesAmount = this.calculateChargeAmount(originalItem);
        const calculatedTaxAmount = this.calculateTaxAmount(originalItem);
        const calculatedTotalAmount = this.calculateTotalAmount(originalItem);
        
        // Lưu các giá trị tính toán vào Pre* để hiển thị
        originalItem.PreChargesAmount = calculatedChargesAmount;
        originalItem.PreTaxAmount = calculatedTaxAmount;
        originalItem.PreTotalAmount = calculatedTotalAmount;
        originalItem.AfterTaxAmount = calculatedTotalAmount;
        if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
          originalItem.PreTaxReduction43Amount = this.calculateTaxReduction(originalItem);
        }
        
        // Tính DisplayUnitPrice cho hiển thị theo cấu hình
        originalItem.DisplayUnitPrice = this.calculateUnitPrice(originalItem);
      } else {
        // Khi không tự động tính toán, sử dụng giá trị đã nhập trực tiếp
        originalItem.PreChargesAmount = originalItem.ChargesAmount;
        originalItem.PreTaxAmount = originalItem.TaxAmount;
        originalItem.PreTotalAmount = originalItem.TotalAmount;
        originalItem.AfterTaxAmount = originalItem.TotalAmount;
        if (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE') {
          originalItem.PreTaxReduction43Amount = originalItem.TaxReduction43Amount;
        }
        
        // Khi không tự động tính toán, sử dụng Price trực tiếp cho DisplayUnitPrice
        originalItem.DisplayUnitPrice = originalItem.Price;
      }
      
      // Cập nhật item vào store và kích hoạt lại render UI
      const storeItem = this.$ls_Items.find(item => item.ItemId === editedItem.ItemId);
      if (storeItem) {
        Object.assign(storeItem, originalItem);
        this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', [...this.$ls_Items]);
      }
      
      // Cập nhật lại biến items để kích hoạt tính toán lại UI
      // Cần tạo một bản sao mới để đảm bảo Vue nhận biết sự thay đổi
      this.items = [...this.items];
      
      // Xử lý lại separate charge rows nếu cần
      if (this.eInvoiceConfig.ChargeOption === 'SEPARATE_ROW') {
        // Xóa các dòng phí riêng hiện tại
        this.items = this.items.filter(item => !item.IsChargeRow);
        // Tạo lại các dòng phí riêng
        this.processSeparateChargeRows();
      }
      
      // Cập nhật lại nhóm và phân trang
      this.$nextTick(() => {
          // Just refresh the existing items in their groups
          this.groupedItems.forEach(group => {
            if (group.items && Array.isArray(group.items)) {
              // Find and update the item in its current group
              const itemIndex = group.items.findIndex(item => item.ItemId === originalItem.ItemId);
              if (itemIndex !== -1) {
                // Update the item in place
                group.items.splice(itemIndex, 1, {...originalItem});
              }
            }
          });
          

          // For other modes, regenerate groups as before
        this.groupedItems = this.initialGroupItems(this.items);
        this.getPagingItems();
        this.getPagingItemGroup();
      });
    },
    
    // Method để làm sạch và validate dữ liệu, tránh duplicate keys
    validateAndCleanData() {
      
      // 1. Kiểm tra và tạo lại ItemId cho các item thiếu hoặc trùng lặp
      const seenItemIds = new Set();
      const duplicateItems = [];
      
      this.items.forEach((item, index) => {
        if (!item.ItemId || seenItemIds.has(item.ItemId)) {
          duplicateItems.push(index);
          item.ItemId = uuidv4();
        }
        seenItemIds.add(item.ItemId);
      });
      
      if (duplicateItems.length > 0) {
        console.log(`Fixed ${duplicateItems.length} duplicate/missing ItemIds`);
      }
      
      // 2. Kiểm tra và tạo lại group.id cho các group thiếu hoặc trùng lặp
      const seenGroupIds = new Set();
      const duplicateGroups = [];
      
      this.groupedItems.forEach((group, index) => {
        if (!group.id || seenGroupIds.has(group.id)) {
          duplicateGroups.push(index);
          group.id = uuidv4();
        }
        seenGroupIds.add(group.id);
      });
      
      if (duplicateGroups.length > 0) {
        console.log(`Fixed ${duplicateGroups.length} duplicate/missing group IDs`);
      }
      
      // 3. Validate items trong groups
      this.groupedItems.forEach(group => {
        if (group.items) {
          group.items.forEach(item => {
            if (!item.ItemId) {
              item.ItemId = uuidv4();
            }
          });
        }
      });
      
      console.log('Data validation completed');
    },

    groupItemsByGroupType(items) {
      const nonGroupItems = []; // Store all items that aren't in a group
      let grouped = [];

      // Đảm bảo tất cả các items đều có originalGroup
      items = items.map(item => {
        if (!item.originalGroup) {
          item.originalGroup = item.GroupItemName;
        }
        return item;
      });

      if (!this.selectedGroupOption) {
        nonGroupItems.push(...items)
      } else {
        grouped = items.reduce((groups, item) => {
          // Option 1: Nhóm theo GroupItemId
          if (this.selectedGroupOption === 'GroupItemId') {
            // CHECK HERE: If GroupItemCustomId is null, treat as standalone item
            // Or if both GroupItemId and originalGroup are empty
            if (item.GroupItemName === '' || item.groupItemId === null) {
              // Keep it null to ensure it's treated as standalone
              item.GroupItemCustomId = null;
              item.GroupItemCustomName = '';
              // Add to nonGroupItems instead of any group
              nonGroupItems.push(item);
               return groups;
            }

            // Continue normal grouping for items that should be grouped
            let group = groups.find(group => group.type === item.originalGroup);
            
            if (!group) {
              // Tạo ID an toàn với UUID
              const uniqueId = uuidv4();
              
              group = {
                id: uniqueId,
                title: this.$t(item.originalGroup) || 'Nhóm mới',
                specialTax: item.SpecialTax || 0,
                tax: item.Tax || 0,
                charges: item.Charges || 0,
                items: [],
                type: item.originalGroup || 'default',
                unitName: this.$t('common_unit_default'),
                isCustomGroup: true
              };
              this.$set(group, 'isCollapsed', false);
              this.$set(group, 'isChecked', false);
              groups.push(group);
            }
            
            // Gán vào GroupItemCustomId và GroupItemCustomName thay vì ghi đè lên các trường gốc
            item.GroupItemCustomId = group.id;
            item.GroupItemCustomName = group.title;
            item.GroupUnitName = group.unitName;
            
            group.items.push(item);
            return groups;
          } 
          // Option 2: Nhóm theo Charges
          else if (this.selectedGroupOption === 'Charges') {
            let taxFeeName = '';
            let taxFeeType = '';
            
            if (item.Tax) {
              taxFeeName = this.$t('TAX') + ' ' + item.Tax;
              taxFeeType = 'TAX_' + item.Tax; 
            }

            if (item.Charges) {
              taxFeeName += taxFeeName === '' ? this.$t('CHARGES') + ' ' + item.Charges : ' ' + this.$t('CHARGES') + ' ' + item.Charges;
              taxFeeType += 'CHARGES_' + item.Charges;
            }
            
            // Add this check to ensure items with zero tax and zero charges get the same group type
            if (!taxFeeType) {
              taxFeeType = 'NO_TAX_NO_CHARGES';
              taxFeeName = 'No Tax/Charges';
            }
            
            let group = groups.find(group => group.type === taxFeeType);
            
            if (!group) {
              // Tạo ID an toàn với UUID
              const uniqueId = uuidv4();
              
              group = {
                id: uniqueId,
                title: taxFeeName,
                specialTax: item.SpecialTax || 0,
                tax: item.Tax || 0,
                charges: item.Charges || 0,
                items: [],
                type: taxFeeType,
                unitName: this.$t('common_unit_default'),
                isCustomGroup: true
              };
              this.$set(group, 'isCollapsed', false);
              this.$set(group, 'isChecked', false);
              groups.push(group);
            }
            
            // Gán vào GroupItemCustomId và GroupItemCustomName thay vì ghi đè lên các trường gốc
            item.GroupItemCustomId = group.id;
            item.GroupItemCustomName = group.title;
            item.GroupUnitName = group.unitName;
            
            group.items.push(item);
            return groups;
          }

          return groups;
        }, []);
      }
      
      grouped = grouped.filter(group => group.items.length > 0);
      return [...grouped, { id: uuidv4(), title: 'NonGroup', items: nonGroupItems, isNonGroup: true }];
    },

    onDragChange(e, group) {
      if (!group.isNonGroup) {
        const temp = this.groupedItems.find(el => el.id === group.id);
        temp.items = [...group.items];
        
        // Cập nhật GroupItemCustomId và GroupItemCustomName thay vì trường gốc
        if (this.draggedItem) {
          this.draggedItem.GroupItemCustomId = group.id;
          this.draggedItem.GroupItemCustomName = group.title;
        }
      } else {
        //nonGroup in groupedItems
        const nonGroup = this.groupedItems.find(el => el.isNonGroup);
        nonGroup.items = nonGroup.items.filter(item => item.ItemId !== this.draggedItem.ItemId);
        nonGroup.items.splice(e.moved.newIndex, 0, this.draggedItem);
        
        // Khi kéo ra nonGroup, xóa GroupItemCustomId và GroupItemCustomName
        if (this.draggedItem) {
          this.draggedItem.GroupItemCustomId = null;
          this.draggedItem.GroupItemCustomName = '';
        }
      }
      
      this.$nextTick(() => {
        this.getPagingItemGroup();
        this.getPagingItems();
      })

      this.draggedItem = null;
      this.originalGroup = null;
    },

    onDragStart(e) {
      const originalGroupId = e.from.getAttribute('data-group');
      this.originalGroup = this.getGroupById(originalGroupId);
      this.draggedItem = this.originalGroup.items[e.oldIndex];
    },
    onDragEnd(e) {

      this.originalGroup = null;
      this.draggedItem = null;
    },
    getGroupById(id) {
      return this.groupedItems.find(group => group.id === id);
    },
    
    // === SEPARATE CHARGE ROWS HANDLING ===
    processSeparateChargeRows() {
      // Only process if chargeOption is SEPARATE_ROW
      if (this.eInvoiceConfig.ChargeOption !== 'SEPARATE_ROW') {
        return;
      }

      // Filter out charge rows and keep regular items
      const regularItems = this.items.filter(item => !item.IsChargeRow);
      
      // Find existing charge rows
      const existingChargeRows = this.items.filter(item => item.IsChargeRow);
      
      const chargeRows = [];
      const chargeGroups = {};

      // Process each item to extract charge information
      regularItems.forEach(item => {
        if (!item || typeof item !== 'object' || !(+item.Charges > 0)) {
          return;
        }

        // Create a key for grouping charges by charge value and tax value
        const chargeKey = `${item.Charges}_${item.Tax || 0}`;
        
        if (!chargeGroups[chargeKey]) {
          chargeGroups[chargeKey] = {
            chargeRate: +item.Charges,
            taxRate: +item.Tax || 0,
            items: [],
            totalAmount: 0
          };
        }
        
        // Calculate the base amount for this charge
        const baseAmount = this.calculateChargeBaseAmount(item);
        const chargeAmount = this.calculateChargeDirectly(baseAmount, +item.Charges, this.eInvoiceConfig.MinorUnit ?? 0);
        
        // Add the item to the group and accumulate the total amount
        chargeGroups[chargeKey].items.push({
          itemId: item.ItemId || item.Id, // Use ItemId if available, fallback to Id
          baseAmount,
          chargeAmount
        });
        
        chargeGroups[chargeKey].totalAmount += chargeAmount;
        
        // Lưu lại giá trị gốc vào các biến tạm thời
        const originalChargesAmount = item.ChargesAmount;
        const originalTaxAmount = item.TaxAmount;
        const originalTotalAmount = item.TotalAmount;
        
        // Lưu lại giá trị ChargesAmount gốc để có thể khôi phục lại khi cần
        item.OriginalChargesAmount = originalChargesAmount;
        
        // Set the item's ChargesAmount to 0 for display purposes
        item.ChargesAmount = 0;
        
        // Tính lại TaxAmount và TotalAmount sau khi đã bỏ charge
        // Nếu item có thuế, tính lại thuế trên số tiền không bao gồm phí
        if (+item.Tax > 0) {
          // Đảm bảo tính toán mới hoàn toàn dựa trên trạng thái hiện tại của item (không có phí)
          const baseAmount = (+item.Quantity || 1) * (+item.Price || 0) - (+item.DiscountAmount || 0);
          const newTaxAmount = this.roundTo(baseAmount * (+item.Tax || 0) / 100, this.eInvoiceConfig.MinorUnit ?? 0);
          
          // Cập nhật TaxAmount với giá trị mới không bao gồm phí
          item.TaxAmount = newTaxAmount;
          
          // Tính lại tổng tiền: baseAmount + newTaxAmount
          const newTotalAmount = baseAmount + newTaxAmount;
          item.TotalAmount = newTotalAmount;
          
          // Cập nhật giá trị PreTaxAmount và PreTotalAmount để hiển thị
          item.PreTaxAmount = newTaxAmount;
          item.PreTotalAmount = newTotalAmount;
          
          // Set BeforeTaxAmount và SubAmount cho item gốc
          item.BeforeTaxAmount = baseAmount;
          item.SubAmount = baseAmount;
        } else {
          // Nếu không có thuế, chỉ cần trừ đi phí từ tổng tiền
          const baseAmount = (+item.Quantity || 1) * (+item.Price || 0) - (+item.DiscountAmount || 0);
          item.TotalAmount = originalTotalAmount - originalChargesAmount;
          item.PreTotalAmount = item.TotalAmount;
          
          // Set BeforeTaxAmount và SubAmount cho item gốc
          item.BeforeTaxAmount = baseAmount;
          item.SubAmount = baseAmount;
        }
        
        // Đánh dấu item là đã được xử lý bởi SEPARATE_ROW
        item.ProcessedBySeparateRow = true;
      });

      // Create or update separate charge rows for each charge group
      Object.keys(chargeGroups).forEach(key => {
        const group = chargeGroups[key];
        
        // Check if we already have an existing charge row for this group
        const existingChargeRow = existingChargeRows.find(row => 
          row.IsChargeRow && 
          +row.Tax === group.taxRate && 
          row.Name === `Phụ phí ${group.chargeRate}%`
        );
        
        if (existingChargeRow) {
          // Update existing charge row with new total and items
          existingChargeRow.Price = group.totalAmount;
          existingChargeRow.DisplayUnitPrice = group.totalAmount;
          
          // Recalculate tax amount based on the new price
          existingChargeRow.TaxAmount = group.taxRate > 0 
            ? this.roundTo(group.totalAmount * group.taxRate / 100, this.eInvoiceConfig.MinorUnit) 
            : 0;
            
          // Update the total amount
          existingChargeRow.TotalAmount = group.totalAmount + existingChargeRow.TaxAmount;
          
          // Set BeforeTaxAmount and SubAmount for charge rows using helper method
          this.updateSubAmountAndBeforeTaxAmount(existingChargeRow);
          
          // Set GroupItemId as new GUID and GroupItemName as "CHARGE"
          existingChargeRow.GroupItemId = null;
          existingChargeRow.GroupItemName = null;
          existingChargeRow.GroupItemCustomId = null;
          existingChargeRow.GroupItemCustomName = null;
          
          // Update display values
          existingChargeRow.PreTaxAmount = existingChargeRow.TaxAmount;
          existingChargeRow.PreTotalAmount = existingChargeRow.TotalAmount;
          
          // Update description to reflect the new number of items
          existingChargeRow.Description = `Phụ phí ${group.chargeRate}% áp dụng cho ${group.items.length} sản phẩm`;

          // Set the name from configuration settings
          existingChargeRow.NameConfig = this.eInvoiceConfig.RepresentativeName ?? `Tiền phí`;
          // Update the Name property to use NameConfig
          existingChargeRow.Name = this.eInvoiceConfig.ShowRepresentativeName ? 
            `${existingChargeRow.NameConfig} ${group.chargeRate}%` : 
            `Phụ phí ${group.chargeRate}%`;

          // Update the OriginalItems reference
          existingChargeRow.OriginalItems = group.items.map(i => i.itemId);
          // Cập nhật tham chiếu đến dịch vụ gốc
          existingChargeRow.OriginalItemIds = group.items.map(i => i.itemId);
          
          // Add to the chargeRows array to keep it
          chargeRows.push(existingChargeRow);
        } else {
          // Create a new charge row
          const chargeRow = {
            Id: uuidv4(), // Unique ID using UUID
            ItemId: uuidv4(), // Add ItemId as UUID for consistency
            ItemName: this.eInvoiceConfig.ShowRepresentativeName ? 
              `${this.eInvoiceConfig.RepresentativeName ?? 'Tiền phí'} ${group.chargeRate}%` : 
              `Phụ phí ${group.chargeRate}%`,
            Quantity: 1,
            Price: group.totalAmount,
            DisplayUnitPrice: group.totalAmount,
            Tax: group.taxRate,
            Charges: 0, // No further charge on charge rows
            DiscountAmount: 0,
            ChargesAmount: 0, 
            TaxAmount: group.taxRate > 0 ? this.roundTo(group.totalAmount * group.taxRate / 100, this.eInvoiceConfig.MinorUnit) : 0,
            TotalAmount: group.totalAmount + (group.taxRate > 0 ? this.roundTo(group.totalAmount * group.taxRate / 100, this.eInvoiceConfig.MinorUnit) : 0),
            GroupItemId: null,
            GroupItemName: null,
            GroupItemCustomId: null,
            GroupItemCustomName: null,
            IsChargeRow: true, // Mark as a charge row
            IsDisabled: true, // Disable editing
            OriginalItems: group.items.map(i => i.itemId), // Reference to original items
            // Thêm tham chiếu đến từng dịch vụ gốc để dễ dàng xóa
            OriginalItemIds: group.items.map(i => i.itemId),
            ProcessedBySeparateRow: true, // Đánh dấu là dòng phí riêng
            PreChargesAmount: 0,
            PreTaxAmount: group.taxRate > 0 ? this.roundTo(group.totalAmount * group.taxRate / 100, this.eInvoiceConfig.MinorUnit) : 0,
            PreTotalAmount: group.totalAmount + (group.taxRate > 0 ? this.roundTo(group.totalAmount * group.taxRate / 100, this.eInvoiceConfig.MinorUnit) : 0)
          };
          
          // Set SubAmount and BeforeTaxAmount using helper method
          this.updateSubAmountAndBeforeTaxAmount(chargeRow);
          
          chargeRows.push(chargeRow);
        }
      });

      // Combine regular items and charge rows
      this.items = [...regularItems, ...chargeRows];
      
      // Xóa bỏ các dòng phí mà không còn dịch vụ gốc tương ứng
      this.items = this.items.filter(item => {
        // Nếu không phải dòng phí, giữ lại
        if (!item.IsChargeRow) {
          return true;
        }
        
        // Kiểm tra xem dòng phí có còn tham chiếu đến dịch vụ gốc còn tồn tại không
        const hasValidOriginals = item.OriginalItemIds && 
          item.OriginalItemIds.some(origId => 
            regularItems.some(regItem => regItem.ItemId === origId)
          );
          
        return hasValidOriginals;
      });
    },

    calculateChargeBaseAmount(item) {
      const invoiceType = this.eInvoiceConfig.InvoiceType;
      const discountOption = this.eInvoiceConfig.DiscountOption;
      const chargeOption = this.eInvoiceConfig.ChargeOption;
      
      // Xử lý đặc biệt cho SEPARATE_ROW
      if (chargeOption === 'SEPARATE_ROW') {
        if (discountOption === 'SEPARATE_COLUMN') {
          // Khi discount hiển thị riêng, đơn giá không thay đổi
          const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
          const discountAmount = (+item.DiscountAmount || 0);
          return baseAmount - discountAmount;
        } else if (discountOption === 'ADD_TO_UNIT_PRICE') {
          // Khi discount gộp vào đơn giá, đơn giá đã bị trừ
          // Lấy đơn giá đã trừ discount từ hàm calculateUnitPrice
          const unitPriceAfterDiscount = this.calculateUnitPrice(item);
          return (+item.Quantity || 1) * unitPriceAfterDiscount;
        }
      }
      
      // For VAT_INVOICE
      if (invoiceType === 'VAT_INVOICE') {
        if (discountOption === 'SEPARATE_COLUMN') {
          const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
          const discountAmount = (+item.DiscountAmount || 0);
          return baseAmount - discountAmount;
        } else if (discountOption === 'ADD_TO_UNIT_PRICE') {
          const unitPriceAfterDiscount = this.calculateUnitPrice(item);
          return (+item.Quantity || 1) * unitPriceAfterDiscount;
        }
      }
      
      // For BH_INVOICE
      if (invoiceType === 'BH_INVOICE') {
        if (discountOption === 'SEPARATE_COLUMN') {
          const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
          const discountAmount = (+item.DiscountAmount || 0);
          return baseAmount - discountAmount;
        } else if (discountOption === 'ADD_TO_UNIT_PRICE') {
          const unitPriceAfterDiscount = this.calculateUnitPrice(item);
          return (+item.Quantity || 1) * unitPriceAfterDiscount;
        }
      }
      
      // Default fallback
      const baseAmount = (+item.Quantity || 1) * (+item.Price || 0);
      const discountAmount = (+item.DiscountAmount || 0);
      return baseAmount - discountAmount;
    },
    
    // Hàm xóa một item
    removeAt: function (itemIdRemove) {
      // Tìm item cần xóa để sau đó xóa các dòng phí liên quan
      const itemToRemove = this.items.find(item => item.ItemId === itemIdRemove || item.id === itemIdRemove);
      
      if (itemToRemove) {
        // Tìm các dòng phí tương ứng với dịch vụ bị xóa
        const relatedChargeRows = this.items.filter(item => 
          item.IsChargeRow && item.OriginalItemIds && 
          item.OriginalItemIds.includes(itemToRemove.ItemId || itemToRemove.id)
        );
        
        // Xóa các dòng phí liên quan
        const chargeIdsToRemove = relatedChargeRows.map(item => item.ItemId || item.id);
        
        // Xóa item và các dòng phí khỏi danh sách items
        this.items = this.items.filter(item => 
          (item.ItemId !== itemIdRemove && item.id !== itemIdRemove) && 
          !chargeIdsToRemove.includes(item.ItemId) && 
          !chargeIdsToRemove.includes(item.id)
        );
        
        // Cập nhật store để đồng bộ với preview modal
        // Cũng cần xóa item từ store
        const updatedStoreItems = this.$ls_Items.filter(item => 
          (item.ItemId !== itemIdRemove && item.id !== itemIdRemove) && 
          !chargeIdsToRemove.includes(item.ItemId) && 
          !chargeIdsToRemove.includes(item.id)
        );
        this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', updatedStoreItems);
        
        // Nếu đang sử dụng SEPARATE_ROW, xử lý lại các dòng phí
        if (this.eInvoiceConfig.ChargeOption === 'SEPARATE_ROW') {
          // Xóa tất cả các dòng phí
          this.items = this.items.filter(item => !item.IsChargeRow);
          // Tính toán lại các dòng phí
          this.processSeparateChargeRows();
        }
      }
      
      // Cập nhật lại các group
      var canBreak = false;
      var self = this;
      this.groupedItems.forEach(function (value, groupIndex) {
        if (canBreak) {
          return true;
        }

        value.items.forEach(function (value, itemIndex) {
          if (value.id === itemIdRemove || value.ItemId === itemIdRemove) {
            canBreak = true;
            self.groupedItems[groupIndex].items.splice(itemIndex, 1);
            return true;
          }
        });
      });
      
      // Cập nhật lại phân trang
      this.$nextTick(() => {
        this.getPagingItems();
        this.getPagingItemGroup();
      });
    },
    // Add external service function
    addExternalService() {

      let nonGroup = this.groupedItems.find(group => group.hasOwnProperty('isNonGroup'));
      if (!nonGroup) {
        this.groupedItems.push({ id: uuidv4(), title: '', items: [], isNonGroup: true });
        nonGroup = this.groupedItems.find(group => group.hasOwnProperty('isNonGroup'));
      }

      this.$nextTick(() => {
        // Tạo item mới với các giá trị mặc định
        const uniqueItemId = uuidv4();
        const newItem = {
          ItemId: uniqueItemId,
          ItemName: '',
          // Set these explicitly to null/empty to ensure no grouping
          GroupItemId: null, 
          GroupItemName: '',
          GroupItemCustomId: null,
          GroupItemCustomName: '',
          Unit: 0,
          UnitName: '',
          Quantity: 1, // Default là 1 thay vì 0
          Price: 0, // Giá gốc
          DisplayUnitPrice: 0, // Giá hiển thị = giá gốc khi chưa có discount/charge
          DiscountAmount: 0,
          Charges: 0,
          ChargesAmount: 0,
          Tax: 0,
          TaxAmount: 0,
          TotalAmount: 0,
          AfterTaxAmount: 0,
          // Initialize SubAmount and BeforeTaxAmount for new items
          SubAmount: 0, // Will be calculated based on Quantity * Price
          BeforeTaxAmount: 0, // Same as SubAmount for new items
          isChecked: false,
          isAdded: true
        };

        // Thêm vào danh sách items và group
        this.items.push(newItem);
        nonGroup.items.push(newItem);
        
        // Initialize SubAmount and BeforeTaxAmount using helper method
        this.updateSubAmountAndBeforeTaxAmount(newItem);
        
        // Tính toán DisplayUnitPrice từ Price - chỉ để hiển thị
        const displayPrice = this.calculateUnitPrice(newItem);
        // Không thay đổi giá trị gốc, chỉ lưu vào thuộc tính hiển thị
        newItem.DisplayUnitPrice = displayPrice;

        // Tính toán các giá trị hiển thị, không thay đổi giá trị gốc
        if (this.isAutoCalculateMoney) {
          // Tính toán các giá trị nhưng không lưu vào ChargesAmount, TaxAmount, TotalAmount
          const chargeAmount = this.calculateChargeAmount(newItem);
          const taxAmount = this.calculateTaxAmount(newItem);
          const totalAmount = this.calculateTotalAmount(newItem);
          
          // Chỉ lưu vào PreXXX để sử dụng cho hiển thị và so sánh
          newItem.PreChargesAmount = chargeAmount;
          newItem.PreTaxAmount = taxAmount;
          newItem.PreTotalAmount = totalAmount;
          
          if (this.isBHInvoice) {
            const taxReduction = this.calculateTaxReduction(newItem);
            newItem.PreTaxReduction43Amount = taxReduction;
          }
        }
        
        // Update pagination
        this.totalPagination.TotalRecord = this.items.length;
        this.totalPagination.TotalPage = Math.ceil(
          this.totalPagination.TotalRecord / this.paging.PageSize
        );

        // Process separate charge rows if needed
        if (this.eInvoiceConfig.ChargeOption === 'SEPARATE_ROW' && (+newItem.Charges > 0)) {
          // Process the separate charge rows to update existing charge rows or create new ones
          this.processSeparateChargeRows();
        }
        this.groupedItems = this.initialGroupItems(this.items);
        // Update paging
        this.getPagingItems();
        this.getPagingItemGroup();
        
        // Đảm bảo UI được cập nhật
        this.$forceUpdate();
      });
    },

    mergeSelectedItem() {
      const newGroupKey = {
        GroupItemCustomId: uuidv4(),
        GroupItemCustomName: 'Nhóm mới',
        GroupUnitName: this.$t('common_unit_default')
      }

       // 1. First get all the ItemIds we're modifying
      const selectedItemIds = this.selectedItems.map(item => item.ItemId);
      
      // 2. Update the selected items
      this.selectedItems.forEach(item => {
        item.GroupItemCustomId = newGroupKey.GroupItemCustomId;
        item.GroupItemCustomName = newGroupKey.GroupItemCustomName;
        item.GroupUnitName = newGroupKey.GroupUnitName;
        item.isChecked = false;
      });
      
      // 3. Directly update the corresponding items in this.items
      this.items = this.items.map(item => {
        if (selectedItemIds.includes(item.ItemId)) {
          // Apply the same changes to matching items
          item.GroupItemCustomId = newGroupKey.GroupItemCustomId;
          item.GroupItemCustomName = newGroupKey.GroupItemCustomName;
          item.GroupUnitName = newGroupKey.GroupUnitName;
          item.isChecked = false;
        }
        return item;
      });
      // Remove selected item in groupedItems
      this.groupedItems = this.groupedItems.map(group => {
        group.items = group.items.filter(item => !this.selectedItems.some(sItem => sItem.ItemId === item.ItemId));
        return group;
      })
      
      const uniqueItemIds = Array.from(new Set(this.selectedItems.map(item => item.ItemId)));
      const uniqueSelectedItems = uniqueItemIds.map(id => { return this.selectedItems.find(item => item.ItemId === id) })
      
      const newGroup = {
        id: newGroupKey.GroupItemCustomId,
        title: this.$t(newGroupKey.GroupItemCustomName),
        items: uniqueSelectedItems,
        unitName: this.$t(newGroupKey.GroupUnitName),
        isChecked: false,
        isCollapsed: false,
        isCustomGroup: true
      }
      
      this.$set(newGroup, 'isCollapsed', false);
      this.$set(newGroup, 'isChecked', false);
      
      // Then add a new group to the end of list
      this.groupedItems.push(newGroup);

      this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', [...this.items]);
      // Every item is added to new group, clear data
      this.selectedItems = [];
      this.$nextTick(() => {
        this.isCheckedAll = false;
        newGroup.isChecked = false;
        this.getPagingItemGroup();
      })
    },

    separateSelectedItems() {
      // First check if we have both grouped and ungrouped items selected
      const hasGroupedItems = this.selectedItems.some(item => item.GroupItemCustomId !== null);
      const hasUngroupedItems = this.selectedItems.some(item => item.GroupItemCustomId === null);
      const mixedSelection = hasGroupedItems && hasUngroupedItems;
      
      // Mark which items were ACTUALLY ungrouped so we can indent them correctly
      this.selectedItems.forEach(item => {
        // Only mark items that are actually ungrouped
        item.wasAlreadyUngrouped = item.GroupItemCustomId === null;
      });
      
      // Đánh dấu các items với trạng thái tách biệt
      this.selectedItems.forEach(item => {
        // Xóa GroupItemCustomId và GroupItemCustomName và GroupUnitName để tách hoàn toàn khỏi nhóm hiện tại
        item.GroupItemCustomId = null;
        item.GroupItemCustomName = '';
        item.GroupUnitName = '';
        // Thêm flag để đánh dấu đây là item đã được tách
        item.isSeparated = true;
        // Mark for indentation based on whether it was previously grouped
        item.needsIndentation = !item.wasAlreadyUngrouped && mixedSelection;
        item.isChecked = false;
      });

      // Xóa các items được tách ra khỏi nhóm cũ
      this.groupedItems = this.groupedItems.map(group => {
        group.items = group.items.filter(item => !this.selectedItems.some(sItem => sItem.ItemId === item.ItemId));
        return group;
      });
      
      // Loại bỏ nhóm rỗng
      this.groupedItems = this.groupedItems.filter(group => {
        return group.items.length > 0 || group.hasOwnProperty('isNonGroup');
      });

      // Lấy nonGroup để đưa các items tách ra vào đó
      let nonGroup = this.groupedItems.find(group => group.hasOwnProperty('isNonGroup'));
      if (!nonGroup) {
        nonGroup = { 
          id: uuidv4(), 
          title: 'NonGroup', 
          items: [], 
          isNonGroup: true,
          isCollapsed: false,
          isCustomGroup: false
        };
        this.groupedItems.push(nonGroup);
      }
      else {
        nonGroup.isCollapsed = false;
      }
      
      // Đưa các items đã tách vào nhóm nonGroup
      const itemsToAdd = [];
      this.selectedItems.forEach(item => {
        if (!itemsToAdd.some(el => el.ItemId === item.ItemId)) {
          itemsToAdd.push(item);
        }
      });
      
      nonGroup.items.push(...itemsToAdd);

      // Reset trạng thái chọn
      this.selectedItems = [];
      this.isCheckedAll = false;
      
      // Đảm bảo tất cả các group checkbox cũng được bỏ tick
      this.groupedItems.forEach(group => {
        group.isChecked = false;
      });
      this.$nextTick(() => {
        this.getPagingItemGroup();
      });
    },

    isCanAddToGroup(item, group) {
      return +item.Charges === +group.charges && +item.Tax === +group.tax && +item.SpecialTax === +group.specialTax;
    },

    deleteSelectedItems() {
  const isSelectedItemInStore = this.selectedItems.some(sItem => this.$ls_Items.some(item => item.ItemId === sItem.ItemId))

  // Xác định ItemId của các dịch vụ bị xóa để sau đó xóa các dòng phí liên quan
  const selectedItemIds = this.selectedItems.map(item => item.ItemId);
  
  // Xác định các dòng phí tương ứng với các dịch vụ bị xóa
  const relatedChargeRows = this.items.filter(item => 
    item.IsChargeRow && item.OriginalItemIds && 
    item.OriginalItemIds.some(origId => selectedItemIds.includes(origId))
  );
  
  // Thêm các dòng phí tương ứng vào danh sách các item cần xóa
  const itemsToDelete = [...this.selectedItems, ...relatedChargeRows];
  const itemIdsToDelete = itemsToDelete.map(item => item.ItemId);

  // Update local items first
  this.items = this.items.filter(item => !itemIdsToDelete.includes(item.ItemId));
  
  // Special handling for ADJUST and REPLACE_INVOICE modes
  if (this.actionType === INVOICE_ACTION.ADJUST_INVOICE || 
      this.actionType === INVOICE_ACTION.REPLACE_INVOICE ||
      this.actionType === INVOICE_ACTION.ADJUST_INCREASE_INVOICE ||
      this.actionType === INVOICE_ACTION.ADJUST_DECREASE_INVOICE || 
      this.actionType === INVOICE_ACTION.CHANGE_INVOICE ||
      this.actionType === INVOICE_ACTION.ADJUST_INVOICE_INFORMATION || 
      this.actionType === INVOICE_ACTION.ADJUST_INVOICE_VALUE) {
    
    // Only update the local items without modifying the store
    // This preserves the original items in the store while removing them from the view
    console.log('Special handling for adjustment modes - keeping store intact');
    
    // Update local groups - this is safe for all modes
    this.groupedItems = this.groupedItems.filter(group => {
      group.items = group.items.filter(gItem => !itemIdsToDelete.includes(gItem.ItemId))
      return group.items.length > 0;
    });
    
    // Skip the store updates for these modes
    this.selectedItems = [];
    this.isCheckedAll = false;
    
    // Recalculate separate charge rows if needed
    if (this.eInvoiceConfig.ChargeOption === 'SEPARATE_ROW') {
      this.processSeparateChargeRows();
    }
    
    // Update UI
    this.$nextTick(() => {
      this.getPagingItems();
      this.getPagingItemGroup();
    });
    
    return; // Exit early - don't update store
  }

  // Normal mode - update both local and store items
  const filteredItem = this.$ls_Items.filter(item => !itemIdsToDelete.includes(item.ItemId)) || [];
  
  //Delete items in groupedItems
  this.groupedItems = this.groupedItems.filter(group => {
    group.items = group.items.filter(gItem => !itemIdsToDelete.includes(gItem.ItemId))
    return group.items.length > 0;
  });

  //Filter out group to delete from store - ensure it's never null
  const filteredGroup = (this.$ls_Groups || []).filter(group => {
    //Compare both StoreGroupId & GroupItemId because item may not changed its GroupItemId
    return !this.selectedItems.some(item => 
      item.StoreGroupId === group.GroupItemId || item.GroupItemId === group.GroupItemId
    );
  });

  //Filter out invoice is deleted from store
  const filteredInvoice = this.$ls_Invoices.filter(invoice => {
    const deletedGroup = filteredGroup.filter(group => {
      // Your existing filter logic
      return true; // Simplified for this example
    });
    //If any group item exist in invoice => delete invoice in store
    const isRemove = invoice.InvoiceGroupItems.some(group => deletedGroup.includes(group));

    return isRemove;
  });

  // Ensure we're never passing null values to store commits
  this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', filteredItem || []);
  this.$store.commit('eInvoiceManagement/UPDATE_ADDED_GROUPS', filteredGroup || []);
  
  const deletedInvoices = this.$ls_Invoices.filter(invoice => !filteredInvoice.some(el => el.InvoiceId === invoice.InvoiceId))
  
  if (deletedInvoices.length > 0 && isSelectedItemInStore) {
    this.$store.commit('eInvoiceManagement/UPDATE_ADDED_INVOICES', filteredInvoice || []);
  }

  if (isSelectedItemInStore) {
    //When any item, group, invoice get deleted isSelectedAll state always set to false
    this.$store.commit('eInvoiceManagement/SELECT_ALL', false);
  }

  this.selectedItems = [];
  this.isCheckedAll = false
  
  // Recalculate separate charge rows if option is enabled
  if (this.eInvoiceConfig.ChargeOption === 'SEPARATE_ROW') {
    this.processSeparateChargeRows();
  }
  
  this.$nextTick(() => {
    this.getPagingItems();
    this.getPagingItemGroup();
  })
},
    //#region Calculate Money
    formatMoney(number) {
      const decimals = this.eInvoiceConfig?.PriceMinorUnit ?? 2;
      const num = Number(number);

      if (isNaN(num)) return '0.00'; // hoặc return '0' nếu bạn không cần phần thập phân

      return new Intl.NumberFormat('vi-VN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    },
    formatItemName(name) {
      if(name.length > 50)
        return name.slice(0,50) + "..."
      else
        return name
    },
    formatMoneyWithNoFraction(number) {
      const decimals = this.eInvoiceConfig?.MinorUnit ?? 0;
      const num = Number(number);

      if (isNaN(num)) return '0';

      return new Intl.NumberFormat('vi-VN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    },


    //#endregion

    //#region EInvoiceConfig
    showChargeColumn() {
      return this.eInvoiceConfig.ChargeOption === 'SEPARATE_COLUMN' || 
      this.eInvoiceConfig.ChargeOption === 'DISPLAY_IN_TOTAL';
      
    },
    
    showChargePercentColumn() {
      return this.eInvoiceConfig.ShowChargePercent;
    },

    showTaxColumn() {
      // Hide tax column for BH_INVOICE
      return (this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN' ||
        this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN_AND_DISPLAY_IN_TOTAL' ||
        this.eInvoiceConfig.TaxOption === 'DISPLAY_IN_TOTAL') &&
        (this.eInvoiceConfig.InvoiceType !== 'SALES_INVOICE' && 
         this.eInvoiceConfig.InvoiceType !== 'BH_INVOICE');
    },

    showTaxPercentColumn() {
      // Hide tax percent column for BH_INVOICE
      return this.eInvoiceConfig.ShowTaxPercent && this.showTaxColumn();
    },

    showDiscountColumn() {
      return this.eInvoiceConfig.DiscountOption === 'SEPARATE_COLUMN';
    },

    showTaxDetail() {
      return this.eInvoiceConfig.ShowTaxDetail &&
        (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE' || this.eInvoiceConfig.InvoiceType === 'VAT_INVOICE');
    },

    showTaxAtTotalSection() {
      return (this.eInvoiceConfig.TaxOption === 'DISPLAY_IN_TOTAL' || this.eInvoiceConfig.TaxOption === 'SEPARATE_COLUMN_AND_DISPLAY_IN_TOTAL') &&
        (this.eInvoiceConfig.InvoiceType === 'BH_INVOICE' || this.eInvoiceConfig.InvoiceType === 'VAT_INVOICE');
    },
    //#endregion EInvoiceConfig

    //b-form-input formatter function
    formatter(value, formatType) {
      if (!formatType) return;
      if (formatType === 'integerNumOnly') {
        return value.replace(/[^1-9]\d*/g, '')
      }
      if (formatType === 'floatNumOnly') {
        return value.replace(/[^d+(\.\d+)?$]/g, '')
      }
    },

    sanitizeDecimal(value) {
      let cleaned = value.replace(/[^0-9.]\d*/g, '');
      const count = cleaned.split('.').length - 1;
      if (count > 1) {
        return cleaned.slice(0, cleaned.length - 1);
      }
      return cleaned.slice(0, 100);
    },

    //Function to check ChargesAmount & TaxAmount & TotalAmount whether equal or not
    haveDiffAmount(item) {
      // Khi tự động tính toán bật, chỉ hiển thị dòng đỏ nếu có sự khác biệt giữa giá trị thực và giá trị tính toán
      if (this.isAutoCalculateMoney) {
        // return item.ChargesAmount !== item.PreChargesAmount ||
        //        item.TaxAmount !== item.PreTaxAmount ||
        //        item.TotalAmount !== item.PreTotalAmount;
        return
      } 
      // Khi tự động tính toán tắt, luôn hiển thị dòng đỏ nếu có sự khác biệt giữa giá trị thực và giá trị lẽ ra theo công thức
      else {
        const calculatedChargeAmount = this.calculateChargeAmount(item);
        const calculatedTaxAmount = this.calculateTaxAmount(item);
        const calculatedTotalAmount = this.calculateTotalAmount(item);
        
        return item.ChargesAmount !== calculatedChargeAmount ||
               item.TaxAmount !== calculatedTaxAmount ||
               item.TotalAmount !== calculatedTotalAmount;
      }
    },
    
    // Mở popup để chỉnh sửa sản phẩm/dịch vụ
    openItemEditPopup(item) {
      this.selectedEditItem = JSON.parse(JSON.stringify(item));
      this.$refs.itemEditPopup.showModal(item);
    },

    //Clear Vuex store
    clearStore() {
      this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', []);
      this.$store.commit('eInvoiceManagement/UPDATE_ADDED_GROUPS', []);
      this.$store.commit('eInvoiceManagement/UPDATE_ADDED_INVOICES', []);
      this.$store.commit('eInvoiceManagement/SELECT_ALL', false);
    },
    selectGroupOption(option) {
      this.selectedGroupOption = option.value
    }
  },
  watch: {
    selectedGroupOption(newVal) {
      if (!newVal) return;
      
      // Skip regrouping in view_detail mode or during adjust invoice operations
      if (this.typeDisplay === 'view_detail') { return; }
      
      // Reset selected items when changing grouping option
      this.selectedItems = [];
      this.isCheckedAll = false;
      
      // Generate new grouped items with proper GroupItemId and GroupItemName updates
      this.groupedItems = this.groupItemsByGroupType(this.items);
      
      // Initialize collapsed state for all groups
      this.isCollapsed = Object.keys(this.groupedItems).reduce((state, index) => {
        state[index] = false;
        return state;
      }, {});
      
      // Update UI with the new groups
      this.getPagingItemGroup();
    },
    
    $ls_Items(newVal, oldVal) {
    this.$nextTick(() => {
      // Bỏ qua xử lý khi đang ở mode view_detail
      if (this.typeDisplay === 'view_detail') {
        console.log('Skip $ls_Items watcher in view_detail mode');
        return;
      }
      
      // Trường hợp store đã trống, clear local items
      if (newVal.length === 0) {
        this.items = [];
        this.groupedItems = [];
        this.getPagingItems();
        this.getPagingItemGroup();
        return;
      }
      
      // QUAN TRỌNG: Không dùng logic kiểm tra oldVal vs newVal
      // Thay vì kiểm tra oldVal và newVal, so sánh this.items với newVal
      // để phát hiện items mới
      
      // Tạo map các ItemId hiện có trong this.items để kiểm tra nhanh
      const existingItemMap = new Map();
      this.items.forEach(item => {
        if (item.ItemId) {
          existingItemMap.set(item.ItemId, item);
        } else if (item.Id) {
          existingItemMap.set(item.Id, item);
        }
      });
      
      // Tìm các items thực sự mới từ store
      const actualNewItems = newVal.filter(storeItem => {
        const itemId = storeItem.ItemId || storeItem.Id;
        return !existingItemMap.has(itemId);
      });
      
      console.log('Detected new items from addToInvoice:', actualNewItems.length);
      
      // Chỉ xử lý khi có items mới
      if (actualNewItems.length > 0) {
        // Chuẩn bị items mới với các giá trị mặc định cần thiết
        const preparedNewItems = actualNewItems.map(item => {
          // Clone để tránh thay đổi dữ liệu trong store
          const newItem = structuredClone(item);
          
          newItem.isChecked = false;
          
          // Tính các giá trị tiền tệ - tính ngược từ TotalAmount (AfterTaxAmount) từ API
          if (this.isAutoCalculateMoney) {
            // Giữ nguyên TotalAmount từ API làm giá trị after-tax
            // Tính ngược Price từ TotalAmount
            newItem.Price = this.calculateInvertedUnitPrice(newItem);
            
            // Tính ngược ChargesAmount và TaxAmount từ TotalAmount
            newItem.ChargesAmount = this.calculateInvertedChargeAmount(newItem);
            newItem.TaxAmount = this.calculateInvertedTaxAmount(newItem);
            
            // Tính DisplayUnitPrice từ Price mới
            newItem.DisplayUnitPrice = this.calculateUnitPrice(newItem);
            
            // Tính và set SubAmount và BeforeTaxAmount
            this.updateSubAmountAndBeforeTaxAmount(newItem);
            
            // Lưu vào Pre* để hiển thị
            newItem.PreChargesAmount = newItem.ChargesAmount;
            newItem.PreTaxAmount = newItem.TaxAmount;
            newItem.PreTotalAmount = newItem.TotalAmount;
            
            if (this.isBHInvoice) {
              newItem.TaxReduction43Amount = this.calculateTaxReduction(newItem);
              newItem.PreTaxReduction43Amount = newItem.TaxReduction43Amount;
            }
          } else {
            // Khi không tự động tính toán, sử dụng giá trị đã có từ API
            newItem.DisplayUnitPrice = this.calculateUnitPrice(newItem);
            this.updateSubAmountAndBeforeTaxAmount(newItem);
            newItem.PreChargesAmount = newItem.ChargesAmount || 0;
            newItem.PreTaxAmount = newItem.TaxAmount || 0;
            newItem.PreTotalAmount = newItem.TotalAmount || 0;
            if (this.isBHInvoice && !(+newItem.TaxReduction43Amount > 0)) {
              newItem.TaxReduction43Amount = this.calculateTaxReduction(newItem);
              newItem.PreTaxReduction43Amount = newItem.TaxReduction43Amount;
            }
          }
          
          return newItem;
        });
        
        // Thêm items mới vào cuối danh sách
        this.items.push(...preparedNewItems);
        
        // Xử lý separate charge rows nếu cần
        if (this.eInvoiceConfig.ChargeOption === 'SEPARATE_ROW') {
          this.processSeparateChargeRows();
        }
        
        // Cập nhật groups - thêm vào nonGroup
        let nonGroup = this.groupedItems.find(group => 'isNonGroup' in group);
        if (!nonGroup) {
          this.groupedItems.push({ id: uuidv4(), title: 'NonGroup', items: [], isNonGroup: true });
          nonGroup = this.groupedItems.find(group => 'isNonGroup' in group);
        }
        
        // Thêm các items mới vào nonGroup
        nonGroup.items.push(...preparedNewItems);
        
        // Validate để tránh duplicate keys
        this.validateAndCleanData();
        
        // Cập nhật pagination
        this.totalPagination.TotalRecord = this.items.length;
        this.totalPagination.TotalPage = Math.ceil(
          this.totalPagination.TotalRecord / this.paging.PageSize
        );
        
        // Cập nhật UI
        this.getPagingItems();
        this.getPagingItemGroup();
      }
    });
  },
  },

  beforeDestroy() {
    this.clearStore();
  }
};